module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p17"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p17"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("1.1")])])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("PLANETS IN THEIR STATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p15"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("2160.9.3 Standard Mission Time")])])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("(30 July, 2163 UT)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p15"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p15"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("1.1.1")])])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("The Head was setting with a wild profusion of purples and")]), _vm._v(" blues into the western horizon while Achernar, a brilliant blue star, watched coldly from the north. To the south auroras whipped through the upper atmosphere, humming and crackling with startling energy. Opposite the sunset, setting around the far side of Athena, was the glint of light that was all that could be seen of the"), _c('i', [_vm._v(" Mayor")]), _vm._v("; directly above that hung another speck of light: the alien installation designated Spindle Nine. In between, at the summit of a mighty chunk of rock and ice thirty kilometers high, stood Peter Alander.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The potential extinction of his species had never concerned him less than at that precise moment.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Athena was an unusual world—but then, he thought, they all were. In most respects—radius, mass, density, gravity, etc.—this one was up the scale from Earth. Its sun was the B3V star called Head of Hydras, bluer and more intense than Sol. Athena’s magnetic field was bombarded by all manner of radiation and particles every one of its seventeen and a half hour days, and Alander would have been dangerously exposed to the interplanetary elements so high up in the atmosphere, had he not been wearing a Spinner Immortality Suit, or I-suit, as they were increasingly being called. Several hundred kilometers to his left crouched the base of the orbital tower connecting the planet to the spindle above. Where he stood, on the highest point of the planet, was just one of several very large and very tall mountain-islands girdling the equator. But for the solar weather, Athena could have been made for skyhooks.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The planet’s signature quirk revolved around those mountainous islands, jutting out of the surface of the planet like strange volcanic growths. Over many millions of years, the seas had evaporated into the upper atmosphere Mid deposited themselves as ice on the mountains, increasing their bulk even more. As a result, most of the planet’s water had been trapped in solid form, leaving only a thin, salty scum of an ocean behind. Life blossomed around the bases of the giant islands in strange, linear landscapes. Caught between salt and ice and separated by great distances, each coastal biozone had become home to enough wildly diverse phyla to keep a whole army of xenobiologists busy for centuries. A handful of them that had been scooped up and examined by robotic probes from the"), _c('i', [_vm._v(" Michel Mayor")]), _vm._v(" had shown such unique chemistry that they would have caused a scientific revolution back home—had the Earth existed any longer, that is.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander watched the sunset fade from deep purple to black. Stars were starting to poke through the growing darkness, twinkle-free in the thin air. He had seen nights fall on more than a dozen different planets, but this one beat them all for sheer splendor. The night sky was so vivid that if he stood absolutely still and tilted his head back so that all he could see were the stars, it felt as if he was actually"), _c('i', [_vm._v(" in")]), _vm._v(" space.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You cooled off yet?” said a voice in his ear.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He didn’t allow himself a smile. Cleo would note the expression from his bioreadings, and he wasn’t going to give her the satisfaction.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“This isn’t just a bad mood,” he said. “You realize that, don’t you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I realize more than you give me credit for,” she replied. “You hate being outvoted, for one.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m glad you noticed. That’s one of the few human traits I have left.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Not so few. You also hate feeling like an idiot.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He shivered from purely psychosomatic cold but didn’t say anything.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And you love a good argument for its own sake,” she went on. “You"), _c('i', [_vm._v(" love")]), _vm._v(" picking fights—and I dare you to tell me otherwise!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He swallowed an automatic retort. “I think you’re mistaking me for Caryl Hatzis.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Some people would take that as a compliment, you know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Would you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He heard a faint noise from behind him and turned to see her image walking to join him across the crusty high-altitude ice pack. She wasn’t really there, being the product of a conSense illusion piped into his artificial nerve endings by the processors on the"), _c('i', [_vm._v(" Mayor,")]), _vm._v(" but he would have been hard pressed to tell the difference, had she still had a physical body to compare it to. He could even hear her feet crunching in the ice as she approached.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You know how I voted,” she said, coming to a halt in front of him, her blond hair buffeted by the wind. She was wearing a khaki oversuit sealed at wrists and ankles; her face was exposed and caught the light of the auroras in a convincingly eerie way. “Doesn’t that count for anything?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“After Adrasteia—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I know what you’re going to say, Peter,” she interrupted. “After Adrasteia, you don’t trust anyone. Well, that’s something you need to get over, pal. With UNESSPRO gone, there are no traitors in the system anymore. You know that. They either owned up or went psychotic. And if it’s me you’re worried about—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It’s not you, Cleo,” he cut in quickly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I was going to say that if it was me you’re worried about, then you can go to hell,” she said. “Because even if you didn’t already know that Otto was the rotten apple in the"), _c('i', [_vm._v(" Michel Mayor")]), _vm._v(" I think I’ve proved myself a dozen times over. I’m on your side, Peter, except when you’re obviously wrong or just being an idiot.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He raised one hand to brush the hair out of her face. Although she was nothing more than an illusion, his fingers registered every pressure, texture, and temperature he would have expected of the real thing.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("Am")]), _vm._v(" I being an idiot?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her expression softened. “In the long run, no, I don’t think you are,” she said. “But things are changing too fast for the rest to focus on anything but the short term—the present. Christ, Peter, in a single day, the Spinners came and gave them gifts beyond their wildest dreams. Then they heard about the Starfish. First, they were given everything, and now they’re being told they’ve lost everything. You can’t blame them for not liking what you’ve got to say—or at least for being resistant to it. They want a future.” She paused to sigh. “Besides, I don’t think they’re even listening to what you have to say; they’re just hearing the voice of the person saying it. It’s you again: the oracle of doom and gloom. Believe me, Peter, pushing isn’t going to help.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He knew she was right, and she knew he knew, too. He could see it in her expression. There was no point arguing when they were both, more or less, on the same side.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She leaned in close to put her arms around him. He wanted to hug her back, but conSense hadn’t quite perfected a convincing full-body squeeze. Her illusory warmth was enough to take some of the chill out of the brisk night wind, and he was comforted by the contact, even though part of him still thought of Lucia with regret, and probably always would.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“This could be our home, if we let it,” she said, her voice slightly muffled by his shoulder. “We can expand the existing bases, put habitats down on the strands, build more bodies—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I know how it goes, Cleo. Dig in, delve into the gifts, build up resources until we’re able to diversify, disseminate the human race across the stars.” The four Ds made perfect sense on the surface, and he felt their calling more deeply than maybe even Cleo imagined. The argument was fundamentally flawed, though; it assumed that nothing would get in the way of the dream becoming reality. “But can we do this with the Starfish still out there? Would you be prepared to take a chance on raising children here without ever really knowing whether or not they’ll be back to finish us off?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Children?” She pulled away from him so she could look at his face. “Who’s talking about children?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Some of them are,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But"), _c('i', [_vm._v(" I’m")]), _vm._v(" not one of them.” She frowned. “I thought that was already established. I just want a little time to heal.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m not denying anyone that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes you"), _c('i', [_vm._v(" are,")]), _vm._v(" Peter. You want us to make a decision that will affect the rest of our lives. You want us to avoid settling down on the grounds that it might not be safe. But what are you offering instead? Can you tell us when it"), _c('i', [_vm._v(" will")]), _vm._v(" be safe?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He shook his head, tight lipped.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I think I know what my decision will be,” she went on, “but I’m not ready to make it right now. Not yet. I don’t want to commit myself to anything before I feel as though I can support it one hundred percent. Especially something like this, which will affect my entire future.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“If we have one—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She cut him off with a sigh. “Save the speeches for the next meeting,” she said, letting go and stepping back.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m sorry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She hugged herself, rubbing her arms as though cold. On another world, in another time, her lean frame, broad face, and high cheekbones would have lent her enough of a Nordic air that he might have been surprised by her apparent chill. On Athena, though, seventy light-years from the remains of Earth, at thirty below freezing, Alander was very aware that, his hypnotized nerve endings aside, he was interacting with little more than a phantom, invisible to anybody else but him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“If you need to talk to me about anything else,” she said, “you know where I’ll be.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Thanks, Cleo,” he said, meaning it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She walked around him, having learned the habit of vanishing when she was out of sight so as not to disorient him. His mental state was still disturbingly fragile at times.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“By the way,” she said at the last moment, “Caryl wants you to bring the hole ship back. There are some emissions she wants you to check out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He shook his head, amazed by the woman’s arrogance. “I’m not her goddamn dogsbody, Cleo,” he said without facing her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Neither am I,” she said. “Nevertheless, here we are.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He turned then, expecting to see her standing there smiling at him. But she had already gone, her disappearance leaving him seemingly isolated on the giant mountaintop, although in reality he was no more alone than he had been before.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slowly, reluctantly, he returned to where he’d left the hole ship. Apparently unaffected by gravity and whiter than the snow it hung above, the enormous spherical mass of the craft floated over a shallow rift about a hundred meters away. The black cockpit was ready for his return with the light from its open airlock now easily the brightest thing in the landscape around him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He briefly considered complying with Caryl Hatzis’s wishes and returning immediately, but then he decided against it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("To hell with her,")]), _vm._v(" he thought. There was no cause to hurry. The aurora was particularly spectacular tonight, and making her wait half an hour while he enjoyed it wasn’t going to kill her. God knew he’d certainly earned the break.")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("The emissions were coming from a point roughly seven ")]), _vm._v("AUs from the Head and twenty-five degrees above the ecliptic. They consisted of a semiregular pulsing in the upper microwave band and didn’t correlate to any satellite, active or inactive, placed in-system by the"), _c('i', [_vm._v(" Mayor. ")]), _vm._v("Hatzis had thought it might be a piece of Spinner flotsam, which warranted checking it out. Alander agreed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The more the Spinner artifacts were investigated, the clearer it became that the spindles were built by machines, that the Spinners themselves had had nothing actually to do with it. Alander thought that mapping that single fact onto humanity’s experiences with AIs might be misleading, but even he couldn’t resist the assumption that something would inevitably go wrong with any automated process. Somewhere, eventually, the Gifts would make a mistake and leave something behind, some clue that would speak more about their origins than they had ever been willing to reveal.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The question of whether the Gifts would let him return with anything like a clue occupied his mind as he instructed the hole ship AI to take him to a position closer to the source of the emissions. They were programmed not to reveal the origin of their makers; indeed, at times it seemed as though they didn’t even know it themselves. But were they also programmed to keep that knowledge a secret if the humans were to stumble across it? How far would they go to protect their makers? Alander didn’t know, and it worried him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We’ve had word from Sothis,” Hatzis had said to him when he’d checked back in for duty. “They’ve found three more drops.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Drops.")]), _vm._v(" Alander remembered his first sight of a Spinner skyhook unraveling its way from orbit and thought the term very apt. Not every Spinner drop had the same number of towers, but title method was the same in each, as were the number of the gifts.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Any joy?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Two markers,” she answered. “One contact.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A"), _c('i', [_vm._v(" marker")]), _vm._v(" was the euphemism for a destroyed colony, so called because of the strange, inert sculptures left behind in systems visited by the Starfish. These artifacts seemed to serve no function, and some had taken them to be the equivalent of death markers or gravestones. Who planted them, however, remained a mystery. They seemed to employ a similar technology to the hole ships the Spinners left behind, but beyond that, nothing was known.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What’s the contact?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Beta Hydras. Borderline senescent, but the Gifts managed to reactivate some of the archived engrams.” She hesitated before adding, “You weren’t one of them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That was the"), _c('i', [_vm._v(" Carl Sagan")]), _vm._v(",” he said dismissively. “Not one of my missions.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Even if it had been one of his missions, the chances of his persona remaining intact for so long would have been minimal. All of the engrams were unstable, but his was particularly so. He would’ve been lucky to last a year, let alone the seventy-four years since the"), _c('i', [_vm._v(" Sagan")]), _vm._v(" had arrived.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Who did they choose this time?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Neil Russell. Deep-time physicist; kept himself in extreme slow-mo to observe changes on a larger scale than the human. For him, only a few hours had elapsed since the mission arrived. He wasn’t happy about being dragged back up, apparently.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander could imagine. He remembered Russell well enough, although they’d never been friends. He’d gone through entrainment on a hard science ticket, whereas Alander had strictly generalized. When he pictured him in his mind, he saw a tall, scraggy man with black, wiry hair, prone to long, furiously defended silences.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Another difficult contact")]), _vm._v(", Alander mused. If it wasn’t functional unreliability, as in his case, the Spinners seemed to look for people with inbuilt restrictions on information flow. More often than not, they picked the traitors UNESSPRO had insinuated into the missions. How they identified them, though, no one had yet managed to work out.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What else did Sothis say?”"), _c('i', [_vm._v(" Have you and the other members of your little cabal voted me out of the loop yet?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ll fill you in when you get back,” Hatzis said. She rarely appeared in conSense transmissions beyond the confines of the mother ship, but he could hear the smile in her voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Caryl...” he began.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Screwing with your head is one of the few pleasures left to me, Peter,” she said. “At least grant me that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He allowed himself a laugh, then, as she fed him the coordinates and he relayed them to the hole ship AI. The Starfish might have decimated the human race, but there was still hope left. That was what the settlers—the ones who wanted to take what humanity had left and hunker down in the few habitable worlds they’d found—were feeding on. Down that route, the only source of conflict would be between the survivors themselves. Hatzis and Alander were the most prominent of those: the first person to establish contact between one survey team and another, and the sole survivor of Sol. Perhaps it would be best, he thought, to ease back on the arguing—in public, anyway.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("At least she was offering the public something, whereas he had nothing but nebulous fears and equally nebulous plans. Until he had a clear alternative, he supposed that Cleo was right and that he should, perhaps, cut her some slack.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His train of thought was broken by a sudden lurch of the ship that almost threw him off the couch. The stomach of his artificial body leapt to his throat as the ambient gravity in the cockpit shifted wildly beneath him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What—?” he started, clutching at his seat to keep himself upright.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We have arrived,” said the hole ship the same instant the wall screen cleared. Alander saw a wild profusion of angular silver shapes ahead of them: many-pointed stars spinning and exploding in a rush of energy out of a bright central light source coming toward him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Get us out of here! Now!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The view went black as the hole ship jumped. It lurched again, only this time the entire ship shuddered violently. The noise in the cockpit and the vibrations he could feel through the floor suggested someone was scraping a giant saw across the alien vessel’s smooth hull.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I have suffered minor damage,” announced the hole ship blandly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Can you still relocate?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Then take us back to Athena—quickly! If we’re lucky, we might still be able to beat them there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He got up from the couch, every muscle in his body quivering. Adrenaline coursed through his body as he replayed the fleeting image of the silver ships over and over in his mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Starfish.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Despite only getting a brief glimpse, he had no doubts about this. There was no mistaking the knife-slim lines of those ships; even measuring kilometers across, they were lightning fast and as maneuverable as anything Alander had ever seen. The emissions were either a trap or a side effect of their arrival in the system. But where had they come from? What had brought them to Head of Hydras? And why now?")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The journey back, as with the journey there, would only take less than a minute, but for Alander it was an intolerably long time. He paced about the cockpit, racking his brain to understand what was happening while waiting impatiently for the wall screen to clear. This was the only indication that they were at the end of a journey. During the jumps themselves, there was no actual suggestion that the ship was even moving at all. He was protected in the heart of the ship like a mollycoddled child, ignorant of just about everything important to do with the world around him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When the hole ship did finally emerge from wherever it went between locations in the real universe—some physicists had coined the term"), _c('i', [_vm._v(" unspace")]), _vm._v(" to describe the state—Alander was rigid with tension, holding his breath as he stared at the wall screen. As soon as he saw the silver and black framework of the"), _c('i', [_vm._v(" Michel Mayor")]), _vm._v(" hanging before him, apparently undamaged, he was gesticulating, boiling off his excess energy in a vain pretense that it would make a difference to how quickly things happened next.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I want a line opened"), _c('i', [_vm._v(" immediately")]), _vm._v(" to Caryl Hatzis!” Maybe there was still time—"), _c('i', [_vm._v("if")]), _vm._v(" they moved quickly enough.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her image appeared in the screen: dark, stocky, and frowning.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You’re early,” she said with surprise. “I thought—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The Starfish are here!” he cut in urgently. “We need to upload the"), _c('i', [_vm._v(" Mayor")]), _vm._v(" immediately!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Starfish?” Her frown deepened. “But we haven’t used the communicator. They couldn’t have—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Let’s not analyze this now, okay, Caryl? They’re on their way, and I don’t know how much time we have. We need to move, Caryl—"), _c('i', [_vm._v("now")]), _vm._v("!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Time was moving so slowly for him that when she hesitated just for an instant, as though she was about to question his judgment, he found himself balling his fists and wanting to scream his frustration at her:"), _c('i', [_vm._v(" Move it, or you’ll all die!")]), _vm._v(" But then she was suddenly moving faster than he, ramping up to four times the natural clock rate of the"), _c('i', [_vm._v(" Mayor")]), _vm._v(", spouting orders in unintelligible gibberish too fast for him to even follow.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A window opened in the wall screen, indicating that information had started to flow from the"), _c('i', [_vm._v(" Mayor")]), _vm._v(" to the hole ship. He glanced anxiously at it and found biological and astronomical data, not people. He almost called Hatzis to say,"), _c('i', [_vm._v(" What about the people? Get them out first!")]), _vm._v(" But time was of the essence, and he had no idea how long it would take to upload the contents of the survey vessel’s memory banks to the alien storage devices. Perhaps it would only take minutes. Or perhaps, he thought, the gifts could do it more quickly. A minute was a long time under the circumstances; any time he could save might be crucial.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He was halfway through the first syllable of an inquiry to the hole ship when the first of the Starfish appeared around Athena.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The screen flickered as the hole ship announced: “Taking evasive action.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No, wait—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The view changed as they jumped to a higher orbit, away from the survey vessel. The upload from the"), _c('i', [_vm._v(" Mayor ")]), _vm._v("ceased, broken in midflow. Alander gripped the back of the couch as the first Starfish killing vessel was joined by two more. The three of them streaked around the blue white globe below them in a display of fearful energy, peppering the biosphere and inner orbits with red darts that burned white when they exploded. The ten orbital towers of the gifts with their golden spindles in geosynchronous orbit came under heavy fire, three of them blossoming in quick succession like short-lived nova.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Take us back to the"), _c('i', [_vm._v(" Mayor")]), _vm._v("!” Alander shouted. “We have to do something!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The hole ship relocated just in time to catch the edge of one of the darts. The screen went blue, then black. The hole ship seemed to roll end over end for an instant, then relocated again.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Taking evasive action,” the hole ship repeated.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What happened?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The"), _c('i', [_vm._v(" Michel Mayor")]), _vm._v(" has been destroyed,” the AI replied shortly. “We are under attack.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The hole ship bucked beneath him. Battered, disoriented, Alander clung to the couch as though it was a life jacket.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Caryl?” he called. “Cleo?” It was futile, he knew, because they were already dead—as he would be, too, if he didn’t get out of there fast.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The screen flickered back to life. For a moment he saw nothing but stars—just long enough to think that they might have outrun the alien ships—but the brief peace was shattered by the arrival of a weapon last seen in Sol system: a sphere of oddly shaped silver missiles popping into existence around the hole ship, high-energy weapons at the ready, closing in like white cells around an invading virus.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Taking evasive action.” The hole ship’s mantra was barely audible over the deep rumbling that shook the entire craft. It felt to Alander as though the walls were being torn apart around him. “I have suffered damage.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was all happening too quickly. Alander’s thoughts were disjointed and confused. The hole ship was in real danger of being destroyed if he stuck around any longer. Should he run? Save his own skin?"), _c('i', [_vm._v(" Could")]), _vm._v(" he run, given that the Starfish seemed to be following him everywhere he went in the system? How far did their light cone spread? he wondered. He might jump into another trap—and just one more might be enough to finish off the damaged hole ship. He would have to jump a long way to feel safe, and that would take time. And while he was jumping, he couldn’t send a message.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was only one reason to stick around that he could see. It was vital, too, but was it worth dying for?")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("While the hole ship jumped through unspace, he thought about the sunset from the high point of Athena. Perhaps if he hadn’t stayed there so long, if he had investigated the emissions earlier, as Caryl had asked, they might have had more time to do something about the Starfish attack. He might have saved the others. The thought that he had brought about the deaths of his friends and colleagues simply by being stubborn made him feel nauseous, but it also helped him with his decision about what to do. He would have no more deaths on his conscience.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Send a message to Sothis,” he instructed the alien AI. “Tell them...” He stopped to think. Timing was everything. He didn’t know how long the hole ship would last if he told it to stay put long enough to send a message. They were getting only a second or less between each relocation. He would have to keep it brief.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Tell them the Starfish have attacked Head of Hydras without provocation,” he said. “Their tactics have changed.” He added, “No one is safe anymore,” before instructing the hole ship to compress and send the message next time they relocated.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He didn’t have long to wait. The screen cleared to reveal scenes of wild energy release. Strange forces roiled around the hole ship, tossing it like a soap bubble in a hurricane. Around him, Alander felt rather than heard the gonglike ringing of the ftl communicator as the message was sent, as though he was in the middle of a giant church bell. The ringing stuttered momentarily, and the interior illumination of the cockpit dimmed. Then the hole ship seemed to gather itself and the ringing resumed. A second later, it was done.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander’s uncertainty cleared that very instant. He had done his duty."), _c('i', [_vm._v(" Now")]), _vm._v(" he could get the hell out of there.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("On the screen, vast silver shapes overlapped like scales as they swooped in for the kill.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Get us out of here!” he shouted. “As far away as you can!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Taking evasive action,” said the hole ship. “Sustaining damage.” Alander lost his grip on the couch as internal gravity failed entirely. “Concentrating available resources on emergency priority maintenance. Unable to take evasive action. Sustaining—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The screen flickered and died at the same instant as the hole ship’s voice. The lights turned red. One segment of the cockpit tore away, leaving him exposed to the blistering energies of the attack.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The last thing he saw was the invisible membrane of the I-suit boiling away under a purple light and his right forearm melting painlessly back to the bone.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("1.1.2")])])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_c('i')])])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Sixty-seven light-years away, but at the very same moment,")]), _vm._v(" the message from Athena arrived. The hole ship permanently stationed in the heart of McKenzie Base, Sothis’s main habitation complex, resonated like a drum and conveyed Peter Alander’s voice to the one person listening.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Caryl Hatzis felt her legs lose their strength for a moment, and she sat on the couch to listen uneasily to Alander’s troubled words.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("The Starfish have attacked Head of Hydrus without provocation. Their tactics have changed.")]), _vm._v("” A slight hesitation conveyed any number or emotions—tension, fear, determination, perhaps even resignation—then:"), _c('i'), _vm._v("“"), _c('i', [_vm._v("No one is safe anymore")]), _vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("And then silence.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis clenched her flesh-and-blood fist and brought it to her chin.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Fuck,” she said after a few moments of thinking it through. The message had been intended for her, she was sure, but it had also reached every ear within two hundred light-years. There was no recalling it now.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The hole ship resonated again as another message suddenly thrilled through the hole ship’s chassis.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“This is Gou Mang.” It was Hatzis’s own voice, belonging to an older engram from the system 58 Eridani. “Message received.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Nothing more was said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The message was brief and to the point, but it was all the Starfish would need to get a fix on their location. She just hoped that her engram from Gou Mang hadn’t been fool enough to have called from anywhere important. But then, if she couldn’t trust herself, who could she trust?")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She waited in silence for a response to come in from Head of Hydras, from the colony called Athena. But as the seconds ticked by into minutes, she knew there would be no reply from Alander. He was already dead, along with everyone else in the colony.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She also knew that Gou Mang, or maybe even someone closer, would check out the Head as soon as possible to verify the contact. The earliest she could expect such verification, though, would be in a few hours. The closest colony was in HD203244, thirty-odd light-years away. Even at a hole ship’s impressive rate of speed, it would take half a day to get there.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("For now, she would have to take Alander’s message at face value. Everything had changed, and no one was safe anymore.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Fuck,” she said again, driving her fist into the couch.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Out of the 1,000 UNESSPRO missions, barely 100 had been catalogued in the two weeks since the fall of Sol.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("To date, there had been 60 failed missions; 21 Spinner drops; 13 Starfish kills, complete with markers; and six missions that had arrived intact and been untainted by alien contact. Nine missions had experienced anomalous contacts that were still under examination. With every Spinner drop discovered, the facility of the human remnants to examine the status of the remaining survey missions increased dramatically, and the job became that much more achievable—if not still daunting, in the face of the odds. Even with alien technology on their side, and with the number of catalogued systems increasing rapidly, they were still only a handful of survivors in various states of decay.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("And the Starfish front kept rolling onward, snapping at the heels of the Spinners and destroying everything touched by their gifts. The colonists on Athena were just the latest victims of the Starfish attacks.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("What made this one more unsettling for Hatzis was that she had been there only within the last few days. One of her engrams had been on the"), _c('i', [_vm._v(" Michel Mayor")]), _vm._v(" and she had spent a full day with her, discussing the issues confronting the human race. To date, she had found a dozen copies of herself among the colonies. All were equally precious, although the older ones, like Gou Mang, tended to be more obsessively fragile, closer to senescence and therefore better for dangerous missions like the one to Athena. She was happy to indulge them, but at the same time unwilling to risk any part of herself. The Starfish detected every message sent via the Spinner ftl communicators; anything in the vicinity of the transmission would be destroyed if it remained behind long enough. That was how the Starfish had found Adrasteia and Sol—and Varuna and any of the others unlucky enough to test their communicators before being contacted by the survivors. It was all a matter of timing, catching the colonies post-Spinner and pre-Starfish. Until now, anyway...")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Heavy footsteps resounded along the gantry leading to the hole ship hangar. She looked up.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You heard?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes.” Peter Alander strode through the hole ship’s airlock and into the cockpit without breaking stride. His was a very old genus of vat-grown body that had been standard issue on the UNESSPRO missions; more robust and slightly stockier than a natural human body, its skin had a faintly olive hue and sported no body hair at all. He inhabited his body permanently, cogitating exclusively, when required, through a series of processors installed in the body’s skull instead of operating it from remote as was originally intended. Over it he wore one of the gray habitat jumpsuits they had found on Sothis, and over that was the ever-present shimmer of the Spinner I-suit. Her eyes, modified long ago to see in a much wider spread of frequencies than many of the UNESSPRO scientific instruments, had no problem discerning it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She couldn’t help but think of him as the closest thing to genuinely human company she had left—although that might have simply been because she had known him longer. The first and only engram to contact Sol prior to the Starfish invasion, he had been on the verge of a complete mental breakdown when they’d met. A slight scrambling of his internal processes by a random element she had introduced—a procedure she had conducted without his knowledge—seemed to have quashed some of the more dramatic symptoms, but she could never quite tell what he was going to do next. Maybe that was why she tolerated his company over that of the other engrams.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What should we do?” he asked, coming to a halt before the hole ship’s wall screen as though experiencing some sort of revelation from the alien vessel. “Should we withdraw everyone from the area?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Who do we have there?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He fell silent for a few moments as he consulted the mental checklist that he, like she, kept of every colony the survivors had contacted. His thoughts moved with glacial slowness compared to her own, but she liked to keep him feeling useful.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“There’s the"), _c('i', [_vm._v(" Sagan")]), _vm._v(" in Beta Hydras, of course.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She nodded; that was the latest colony they’d found, the one called Bright. Alander still tended to think in terms of missions rather than worlds named, whereas she preferred to acknowledge them by their colony name. “Then there’s the"), _c('i', [_vm._v(" Davies")]), _vm._v(" in Zeta Reticuli, the"), _c('i', [_vm._v(" Chandra- sekhar")]), _vm._v(" in Alpha Mensa, the"), _c('i', [_vm._v(" Tarter")]), _vm._v(" in BSC8061, the"), _c('i', [_vm._v(" Smolin")]), _vm._v(" in HD113283 and the"), _c('i', [_vm._v(" Bracewell")]), _vm._v(" in HD203244.1 think that’s it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She did her own quick mental check and nodded in agreement. The area around Athena that Alander was referring to, less than fifty light-years across, represented not quite 1.5 percent of the thirty-three million cubic light- years of space covered by the UNESSPRO survey. They’d been lucky to find so many active missions within that space. Four of the seven, including Head of Hydras, were Spinner contactees; there were others Alander hadn’t mentioned, which had already been destroyed by the Starfish.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I don’t think we have the resources to move all of them quickly,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Who says we have to move quickly?” asked Alander. “It could be days, even weeks if the Starfish are searching stars systematically.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We don’t know"), _c('i', [_vm._v(" what")]), _vm._v(" they’re doing, Peter. This could just have been a fluke, an unlucky accident.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Don’t give me that.” His expression, when he brought it round to face her, was one of extreme skepticism. “You know what the odds against it are like.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She did. On an interstellar scale, solar systems were minuscule things, more scarce than fish in Earth’s long- gone deep seas: the odds of hitting one at random, let alone one of the few inhabited by humans, were vanishingly small, as pointed out ad nauseam by the mid-twenty-first century’s anti-SETI movement.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Then somehow we screwed up,” she said. “We let something slip. The Starfish can’t be idiots. They’ll be looking for mistakes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Exactly. And they’re listening to everything we say.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“There’s no evidence to suggest they’ve managed to translate our transmissions,” she shot back.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Maybe there is now,” he said, cheeks flushing slightly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You’re arguing for evacuation?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No, not until we have more data, at least. Where would we put everyone?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Sothis has room.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And what if the Starfish come here, Caryl? What then?” His lips tightened. “We won’t be safe"), _c('i', [_vm._v(" anywhere")]), _vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Better an acceptable risk than being dead,” she said soberly, holding his stare long enough to reinforce the challenge, then dropping her gaze.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This was where they differed. Each of them had a clear idea of what was acceptable and what wasn’t. It was just that, at the end of the day, she thought"), _c('i', [_vm._v(" she")]), _vm._v(" was right.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“So we’re supposed to sit here and wait? Is that it?” He paced around the cockpit like a caged animal. “Caryl, one of me just died.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You weren’t alone, Peter.” She felt annoyed that he was claiming the attack on the"), _c('i', [_vm._v(" Michel Mayor")]), _vm._v(" as some sort of personal tragedy. “There was a Caryl Hatzis on that mission, too. As well as a Cleo Samson, a Kingsley Oborn, a Michael Turate, a—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“For Christ’s sake, Caryl,” he snapped. “I"), _c('i', [_vm._v(" know")]), _vm._v(" that. That’s not what I’m saying.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Then what"), _c('i', [_vm._v(" are")]), _vm._v(" you saying, Peter?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“There’s more of you than there is of me,” he said. “You’re—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He stopped, his mouth left hanging for words that seemed to have stuck in his throat.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Although there had been more Peter Alanders sent by UNESSPRO, the fundamental instability of his engrams had reduced their effectiveness. The Alander sent to the Head of Hydrus was so far the only other one that had survived any length of time, so in that respect, she could sympathize with him. Nevertheless, she was curious as to what he’d been about to say she was.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m what, Peter?” she said."), _c('i', [_vm._v(" Lucky? Ungrateful? Spoiled?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It doesn’t matter.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She sighed. “Then tell me what is it you want to do about this.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I don’t know.” He exhaled heavily, shrugging. “We don’t have many options.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s been the case all along,” she pointed out.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“So nothing’s changed. Is that what you think?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Not at all,” she said. “I simply disagree that the change is as fundamental as you think.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He looked at her from beneath furrowed brows and shook his head. “Bullshit.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("With that, he turned and walked from the cockpit, his footsteps booming as he crossed the gantry and headed back into the habitat. She didn’t need to hack into his senses to work out where he was going, but she did anyway.")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("The observation platform overlooked the dried-up bed of a ")]), _vm._v("sea that would have been roughly the size of two Pacific Oceans, before it boiled away. Sothis was a dead world that had once held life. The fierce illumination of Sirius, blazing high above on its slow arc across the sky, had stripped the planet of its water just as significantly complex organisms had appeared. The salty crusts left behind by the oceans held the remains of numerous kinds of single-cell life-forms. According to the experts, given a less harsh climate, another billion years might well have seen creatures walking Sothis’s rocky shores.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But those same experts who had first studied Sothis were themselves now extinct. The McKenzie Base habitats were all that remained of a senescent engram colony, sent from Earth in 2050 along with all the other UNESSPRO missions. Sirius’s close proximity to Sol meant that the"), _c('i', [_vm._v(" David Deutsche")]), _vm._v(" had arrived less than sixteen years after it had left Sol. Nearly 100 years had passed since then, and the engrams who had established a base on the system’s one Earth-like world and seeded the system’s other planets with monitoring stations had all degraded.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The only things that remained of the colony were their machines. Even the numerous artificial bodies with which they had populated the habitats had died, one by one, as the minds behind them had ceased giving them orders to eat and repair themselves.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Engram breakdown wasn’t pretty to watch, and Hatzis had avoided studying the colony’s records too closely. She had made sure Alander had seen them, though. Engrams might have been adequate copies of the mind of a human being for short missions, but they simply weren’t adaptable enough to survive more than a few decades. They couldn’t cope with the changes that inevitably came as a by-product of life. As small errors or random mutations built up in the code that generated them, higher definitions resisted the subtle new pathways each mind wanted to follow. Instead of adapting, the engrams clung to the way they had been, to the selves they had left behind on Earth years ago. Psychosis was inevitable. If they weren’t shut down from the outside, they entered a state Hatzis had heard described as brainlock and ceased to function. When they reached that point, there was no repairing them. It was, she supposed, a sort of natural death for this particular sort of artificial mind—so the term"), _c('i', [_vm._v(" senescence")]), _vm._v(" seemed particularly apt. Whether it was possible to reverse the aging process, she wasn’t sure. Alander’s continued existence suggested that maybe the randomizing was doing him good, but the experiments she was conducting with various copies of herself had yet to yield any clear-cut results.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("All she needed was time, though. Only thirteen days had passed in the real universe since the destruction of Adrasteia, but for her, thinking faster, that was the equivalent of several months. She had shown her engrams ways to cheat the processing budget on the survey missions, so they were working faster, too. Combined, her extended self was working inefficiently but exhaustively on various projects designed to ensure humanity’s long-term survival. All she had to do was live through the coming weeks by avoiding the Starfish as much as possible, and then everything would work out. She would solve the senescence problem, she was sure; then, using Spinner technology, she would unite all of her various parts and commence working on what she would ultimately become. Whatever that was...")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander’s eyes tracked across the dust-filled basin of the dead sea. Upraised rib cages of long-dead sea beasts, Hatzis mused, seeing what Alander saw, would have been much more evocative of the life that had died here than the occasional footprint preserved in the salt crust near the habitat’s egress airlocks. The structure was large enough to hold a community of several dozen people and boasted two shuttle landing pads and the base of what might have been, given time, an orbital tower.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sothis wasn’t a Spinner contactee; by the time the aliens had appeared, the very last of the colonists—Faith Jong—had been dead for almost thirty years. Hatzis remembered Jong as a petite software specialist interested in bonsai and late twentieth-century popular music. It was hard to picture her as the crazed engram that had loaded herself into the operating system of a small fusion reactor and sent the contained nova within critical in order to drive out the darkness creeping over her mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Faith Jong’s memorial was a crater two kilometers wide on the far side of the planet. Thankfully, the explosion hadn’t harmed the main installation, which now served as the counterintelligence base for the remains of humanity. It combined Spinner and human technology, the latter a mix of 2050 and 2150, depending on what resources were available at any given time. It orbited a star that wasn’t typical for human habitation and sat slightly ahead and to one side of the projected Spinner advance. It had a population of two, but if circumstances had their way, that figure would rise considerably.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I know you’re watching me,” said Alander.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Close,")]), _vm._v(" she thought. Through his senses she could see not only the view but hear the whisper of the wind brushing outside of the habitat, feel the cool smoothness of the nanofactured metal rail Alander was holding with both hands, smell the dusty air that had circulated the lifeless habitat for three decades before their arrival, and taste the saliva in his mouth. She couldn’t see him, but she could experience him a thousand times better from the inside. She could even read his thoughts if she wanted to. Only the fact that such familiarity would ruin what little companionship he offered stopped her from doing so. And the fear that his resistance to her plans would turn out to be built on sand. She needed a devil’s advocate as much as she needed her other selves.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Perhaps this does change everything,” she said, placing her voice as a whisper into his ear, “but at the same time, it changes nothing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Of course it does,” he said. “It changes the way we feel about things, Caryl.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Peter, until this happened, our greatest fear was that someone would make a mistake. Just one transmission from the wrong place would bring the Starfish down on us. But if the message from Athena is right, then we could be damned either way now. It’s out of our hands. There’s no point in running anywhere, because nowhere is safe.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“There’s no sense digging in too deeply, though,” he said less stridently than before. “We need to be flexible, to be able to move fast if we need to.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh, I agree,” she said. “And I’ll draw up contingency plans while you’re gone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("That surprised him. “You’re not coming?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She shook her head—unnecessarily, she realized, as he couldn’t see her anyway. “No,” she said. “I think it’s best that one of us stays here to coordinate things. When Thor comes with the hole ship, she can go with you instead. That’ll save you dropping her off on the way.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She felt his brow crease into a frown. “And Thor is...?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“HD92719.” She indulged the question, even though she was sure Alander knew very well which system the Thor colony was in. Given the number of different versions of her she had to deal with, she had adopted the posthuman custom of calling them by the places they had come from. To the others, she was Sol, the sole original human remaining in the universe.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Will you work with her?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Will she be up to it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Of course she will, Peter,” she said tiredly, thinking, "), _c('i', [_vm._v("She’ll be a damn sight more stable than you.")]), _vm._v(" “And she has her own body, so you won’t have to deal with conSense.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She waited while he mulled it over. The question of what the colony of Thor would do without its hole ship was begging. Would he bring it up? she wondered. She would hate to have a dead colony on her conscience, if the Starfish came calling on them, but Thor was far away from Athena, and the work she hoped to do was important enough to justify the risk. And with Alander gone, she would have full access to the hole ship"), _c('i', [_vm._v(" Arachne.")]), _vm._v(" It would obey her orders, unlike the Gifts, and there were plenty of versions of her out there that needed to be contacted, Spinners and Starfish notwithstanding.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("From her higher processing rate, he seemed to take forever to think it over. He stood watching the view, one hand toying with the pendant he wore around his android body’s neck. It consisted of a simple disk made of densely packed carbon, one side reflective, the other carved with barely a dozen words. It read:")])]), _vm._v(" "), _c('p', {
    staticClass: "p15"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("LUCIA CAROLE BENCK")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("2130.05.17")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("“Bliss was it in that dawn to be alive.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("(WORDSWORTH)")])]), _vm._v(" "), _c('p', {
    staticClass: "p15"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander had found it orbiting 53 Aquarius, an empty solar system between his home colony, Adrasteia, and Sol. He carried it with him out of loyalty to Lucia’s memory, she supposed, although his hope of ever seeing her again must be dwindling. She had yet to reach any of her target systems, out of all the solo missions she had been on.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Or perhaps, she thought, the slow turning of the disk in his fingers was a gentle reminder of mortality.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Eventually, he grunted his consent. “Whatever,” he said. “You’re getting hard to tell apart, so I guess it makes no real difference to me who comes along.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He let go of the rail and stalked off through the habitat, perhaps assuming that this would put him beyond her observational range. It didn’t, of course, but she chose not to go with him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Returning to herself, to her self-imposed isolation in the hole ship"), _c('i', [_vm._v(" Arachne,")]), _vm._v(" she looked down at her hands, where they lay folded in her lap. They were flesh and blood, or the closest thing to it that had survived the Spike in Sol system; they weren’t composed of cells grown in a soup and assembled en masse, differentiating as they went. She was"), _c('i', [_vm._v(" human.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("That set her apart from all the others. She felt it keenly. As much as she played it down when she encouraged them to work together, the truth was impossible to ignore: she was the product of 150 years of experience and biological technology a century in advance of anything UNESSPRO had had. She simply wasn’t the same as them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But Alander had the gall to suggest that he couldn’t tell them apart...?")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She smiled."), _c('i', [_vm._v(" Ah,")]), _vm._v(" she thought, realizing:"), _c('i', [_vm._v(" An insult.")]), _vm._v(" That was good. He wouldn’t normally resort to personal attacks when he couldn’t get what he wanted. The fact that he had this time suggested she must have been getting to him. Was it the argument, she wondered, or the randomizing of his thoughts she had introduced? Either way, it was an interesting development.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Sol uploaded the change of plans the moment Thor arrived")]), _vm._v(" in the secondary dock. Thor wasn’t happy about it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“This is bullshit, Sol,” she said, trying to keep a lid on her annoyance but failing. “I didn’t come all this way to baby-sit.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Try to think of the bigger picture, Thor.” The original Hatzis’s voice was placating. “It makes more sense this way.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Thor glowered at the image that came with the words via conSense. The Caryl Hatzis who had survived Sol had done so with a grace her UNESSPRO engrams had never known. She was slimmer, her skeleton was better structured, and she carried herself with confidence. Compared to the circus freak body Thor had been decanted into, she looked like perfection, damn her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But envy aside, Sol was right. It made sense that she should go with Alander. It also made sense that she be mobile in the same way he was. It was just her bad luck that she had drawn the short straw.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No word from Athena yet?” she asked, deliberately moving on from the subject. Sol had told her about the message they’d received from Head of Hydras on her arrival. She hadn’t heard the transmission from the dying colony while in transit.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Gou Mang should be there soon,” said Sol. “Before you leave, why not wait with me over here for news? Then, if we do need to broadcast instructions, you can make a detour along the way.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("With the lack of anything better to do, Thor accepted Sol’s invitation and made her way from her own hole ship to"), _c('i', [_vm._v(" Arachne.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Sothis habitat was spacious and airy compared to the underground structures her crewmates were building on their colony world. Thor was mainly ocean, apart from two diamond-shaped continents and a smattering of islands. The storms were ferocious. She had thought she might welcome Sothis’s arid bleakness, but she was already finding herself missing the distant howl of the wind and moisture in the air. Here the air smelled of nothing but mummification.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Arachne")]), _vm._v(" was identical to the vessel she had flown from HD92719. It had the same cockpit interior, right down to its smell. The AI, when it spoke, had the same voice. She experienced an odd feeling of"), _c('i', [_vm._v(" jamais vu")]), _vm._v(" as she walked through the airlock to find someone different there, as though returning to a home she now found unfamiliar. Her original was sitting on the couch in exactly the same pose as the image she’d seen in conSense.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("She looks like a queen waiting to receive guests,")]), _vm._v(" Thor thought, resisting an urge to genuflect.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“So, where is Peter?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Getting ready,” replied Sol.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Thor frowned. “Packing? What does he think he’s going to need?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“He places great importance on his physicality. It anchors him. I find it simpler to indulge him than to fight him in this instance.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Thor snorted a slight laugh and shook her head. “I remember him from entrainment camp,” she said. “They indulged him there, too. He was their favorite son, their star pupil. He could have gotten away with murder if he’d wanted to.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I think you’ll find he’s different now,” said Sol. Her eyes were gray, almost disturbingly human-looking. There was no hint at all of the furious processing taking place behind them. “Besides, we must be tolerant. He just lost his only active copy, and we need him on our side.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Not as much as we used to,” she said. “The Gifts have shown they’re prepared to talk to others, now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes, but only in the absence of Peter,” Sol returned, admiring her own copy’s narrow-mindedness. Alander was a hero, at the very least, for getting off a warning in time.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The contact for your mission was Donald Schievenin. He was also the UNESSPRO spy, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Thor nodded and shrugged at the same time. “Nobody’s perfect,” she said. “But"), _c('i', [_vm._v(" Peter...")]), _vm._v("?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Quiet. He’s coming.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sol stood as Alander’s artificial body walked up the access ramp and into the cockpit.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Thor’s body was a match for his in size—both dwarfed her original—but hers had retained the XY body type that was a hangover of the artificial genome’s male origin.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Some effort had been made to sculpt the final result into forms resembling their original shapes, but they had ended up with the same eye and skin color. They looked to Thor like brother and sister."), _c('i', [_vm._v(" Frankenstein’s twins,")]), _vm._v(" she thought wryly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Hello, Caryl,” he said, shaking her hand. Her name sounded oddly out of context with her original standing beside her. “Welcome to Sothis.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She nodded stiffly. “Thank you, Peter.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“If it makes you feel any better,” said Sol, “he’s not happy you’re going either.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander looked as unnerved as she felt by the admission. “Let’s just say,” he said, “I don’t like last-minute changes of plans.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You’ve had hours to get used to it, Peter,” said Sol. “And since when have any of our plans ever been written in stone? Like you said earlier, the Starfish force us to be flexible.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Not just the Starfish.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“All right. The Spinners, too. We need a better idea of where they are as much as we need to stay alive.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Agreed. If that was your only motive for sending me away, maybe I’d trust you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Thor felt as though she had walked into the middle of an argument. “Fuck that,” she said. “Is it going to be like this all the way to Groombridge?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He turned his attention to her. “Don’t worry about me,” he said. “I’ll behave. It’s not you I have a problem with. Not yet, anyway.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She was about to tell him precisely what he could do with his attitude when"), _c('i', [_vm._v(" Arachne")]), _vm._v(" began to vibrate with the ringing tones of an ftl message.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The cockpit fell silent as all three stopped their bickering to listen to the transmission the hole ship was about to relay.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“This is Gou Mang in Head of Hydrus,” the message began. “Athena is dead. I repeat: Athena is dead. The gifts are down, and the"), _c('i', [_vm._v(" Michel Mayor")]), _vm._v(" is gone. There are no signs of surface life, no observatory beacons—"), _c('i', [_vm._v("nothing.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Not even a death marker. Everything’s just... dead.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Gou Mang hesitated, and Thor heard all manner of unspoken tension in the silence."), _c('i', [_vm._v(" What is it like to see a colony destroyed?")]), _vm._v(" she wondered. Alander had seen it, as had Sol. Sol had witnessed all of that and more! The destruction of Earth during the Spike, then the destruction of its magnificent remnants by aliens—")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Gou Mang finally came back with: “There’s nothing we can do here. The Starfish can’t be too far away, either, so I’m getting out of here in case the fuckers home in on this transmission and come back to clean up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The transmission ended there, but the silence in "), _c('i', [_vm._v("Arachne")]), _vm._v(" extended until Sol let out a heavy and troubled sigh. It was only then that Thor realized she, too, had been holding her breath.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s it, Thor,” said Sol sullenly. “We have visual confirmation: the Starfish have changed their tactics.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What about the missing marker?” asked Alander. “Could that be significant?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("They both stared incredulously at him. His concern for the marker seemed trivial, given what they had just learned. Then again, she thought, perhaps it was easier to focus on something like that than the death of an entire colony.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I don’t know, Peter,” said Sol, coming around the cockpit and putting the couch between them. “Maybe Gou Mang arrived too early.” She shrugged. “The most important thing is still to plot the progression of the Spinners. We have enough hole ships now to continue surveying the systems around us. We can afford one to jump ahead, to see how far the leading edge is from us. If we’re going to warn the Spinners about what’s going on, then we have to know at least roughly where they are.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Especially if the Starfish are starting to eat into us from behind.” Alander ran a hand across his eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He was tired, stressed, that much was obvious. Was he unstable, too? Thor didn’t like the idea of spending a week or two cooped up in a hole ship cockpit with someone constantly on the edge of a nervous breakdown. But then, her original had done it and survived, so she figured she could also. Perhaps it would become some kind of rite of passage that every version of Hatzis would one day have to endure.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The sooner we get started, the better,” she said, more in response to her train of thought than anything else. “I’m ready whenever you are, Peter.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He nodded once. “Then let’s get this over with,” he said, turning and walking out of"), _c('i', [_vm._v(" Arachne")]), _vm._v(" without looking back.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Thor tore her eyes from his receding back to look over to her original. “Is he always this charming?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sol shrugged slightly. “And then some,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Thor extended her hand, and Sol took it gently in hers. The contrast of olive artificial skin and pale human flesh was shocking, as was the discrepancy in size between their limbs.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("I’m a freak,")]), _vm._v(" Thor mused as she followed Alander to her colony’s hole ship."), _c('i', [_vm._v(" And she’s a goddess, in more ways than one.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("1.1.3")])])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_c('i')])])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Six days later, Alander was regretting his promise to behave.")]), _vm._v(" As"), _c('i', [_vm._v(" Pearl")]), _vm._v(" relocated without incident for the twentieth time that week, in a system classified as AC +48 1595-89, he found himself wishing for an excuse to start an argument. It would certainly have helped the time pass.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("AC +48 1595-89 consisted of a G-type star corresponding almost precisely to Sol, right down to the sunspots creeping across its face, plus seven planets occupying various positions along the spectrum between rock and hydrogen. There was a fat gas giant with rings; there were numerous moons; there was an asteroid belt and a cometary halo; there were deserts and clouds and ice; there was an Earth-like world in the habitable zone. But there was no sign of the mission sent to study it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Pearl,")]), _vm._v(" like every hole ship, was equipped with standard radio and laser broadcast equipment. Alander scrolled through the visual data while Hatzis went through the motions of trying to hail the mission.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“This is Caryl Hatzis of UNESSPRO Mission 154, & V. "), _c('i', [_vm._v("Krasnikov,")]), _vm._v(" hailing UNESSPRO Mission 707."), _c('i', [_vm._v(" Frank Shu, ")]), _vm._v("do you read me? This is UNESSPRO Mission 154 hailing Mission 707. If you can hear me, Vince, please respond.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Vince Mohler was the civilian mission supervisor of Mission 707, in charge of operations once the survey vessel had arrived in-system. He had also been in charge of the"), _c('i', [_vm._v(" Paul Davies,")]), _vm._v(" one of the first successful missions Alander and Hatzis had found following the destruction of Adrasteia. They had encountered him in various roles in a number of other systems as well. It was hard to imagine him being dead, let alone feel any sense of loss, when he was still noticeably active in so many places.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("That was the problem, Alander thought. There might be hundreds of missions left, each with thirty crewmembers, but all those people were really just the same sixty people copied over and over again. He was beginning to feel suffocated, one of the very few singular people left. With the death of his sole remaining stable copy in the Head of Hydras, he was alone again."), _c('i', [_vm._v(" Would anyone miss me if I died, too?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No sign of any gifts,” he said, shaking the thought. Once he would have lingered over the data coming in from the planets in the system, but he was becoming desensitized to the thrill of exploration. He had seen dozens of similar systems in the previous weeks, and many of them had been dead, like this one. AC +48 1595-89 was a time waster. It would be catalogued with the others; its suitability for future colonists would be noted, so Hatzis and her supporters would have somewhere to live when the settlement faction got their way; the failure of the mission would be a footnote added somewhere at the bottom of the file. Then he could move on.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Do you think we should bring"), _c('i', [_vm._v(" Pearl")]), _vm._v(" in closer?” Hatzis interrupted her broadcast to look at the screen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I don’t see the point,” replied Alander. “There’s no one here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What about the Starfish?” she asked. “Any evidence of visitation?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander shook his head slowly as he examined the data. “No debris, no hot spots, no suspicious gas clouds, no death marker.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Damn it,” she said, then cycled through the message one more time before resigning herself to the fact that there was no one around to hear the message anyway.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He could understand her frustration. The exploratory mission to the Spinner front had generated ambivalent data at best."), _c('i', [_vm._v(" Pearl’s")]), _vm._v(" first two ports of call, near neighbors Groombridge 1830 and 61 Ursa Major, had contained successful missions untouched by either Spinners or Starfish. Alander and Hatzis had ejected messenger buoys in each system, microsatellites designed to bring the UNESSPRO missions up to date without requiring"), _c('i', [_vm._v(" Pearl")]), _vm._v(" to stick around too long. From there,"), _c('i', [_vm._v(" Pearl")]), _vm._v(" took them to numerous other systems along the projected front. Many of them had either failed from senescence or simply failed to arrive altogether, including those sent to Tau Ceti, BD+14 2889, Altair, Mufrid, and a high-profile mission sent to Castor and Pollux. Half of the double mission to Procyon and Luyten’s Star had succeeded, and it had been contacted by the Spinners. Gamma Serpens and BD+14 2621 were likewise Spinner drops, thankfully caught in time before they brought the Starfish down upon themselves. Apart from those few active colonies, though, there was just an automated monitoring station around Barnard’s Star to report. Alander doubted any of it would help pin down the Spinners’ progress with much greater accuracy than they already knew.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He performed a quick mental calculation.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We have an hour to the next transmission,” he said. “I suggest we wait to hear it, send our own update along with the usual warning, then get the hell out of here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“In that case, we might as well spend the time collecting as much data as we can.” She shrugged. “Has to be better than sitting around twiddling our thumbs, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander didn’t argue; it was her call. They had spent their time in the hole ship so far trying their best to maintain both distance and politeness. He didn’t know what her original had told her back on Sothis, but she hadn’t brought up the issue of colonization even once, and he had no intentions of rocking the boat now. Not until he’d come up with an alternative, anyway.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He found himself missing his copy from Athena more than he had expected to. They had met on only a couple of occasions, but that had been enough to cement their relationship. The same but different, they had both struggled with Overseer processing problems and were trying to keep their thoughts together as best they could. Their plans to discuss Sol’s intention in more detail had been put to a dramatic end by the Starfish, and Alander sometimes wondered if his other self had experienced any blinding revelations at the last moment, if suddenly everything had become clear.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis instructed"), _c('i', [_vm._v(" Pearl")]), _vm._v(" to take them to a medium polar orbit around the fourth planet and, moments later, the hole ship had relocated smoothly to this location. They performed a cursory sweep for transmissions of any kind from their new position but quickly gave it up for a lost cause. Instead, they concentrated on gathering data about the planet, adding it to the many other examples they had of worlds that might one day be capable of supporting human life.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The globe was unevenly split between land and sea, with only a few small oceans in the northern hemisphere. The southern hemisphere was richly vegetated, relying on deep reserves of groundwater to preserve the water cycle. They christened it Ea, a Babylonian deity whose realm had been the sweetwater ocean under the Earth. It seemed appropriate, Alander felt, as did claiming it in the name of Sol, rather than either of the UNESSPRO missions. Alander didn’t know when there would next be an active government residing in the human home system, but he wasn’t prepared to give up on the idea just yet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The familiar ringing of the ftl communicator brought an end to their brief survey of the planet. The broadcast was scheduled to coincide with midday on Sothis, although it might be broadcast from anywhere, and more often than not, it contained little of interest to their mission. But they listened to it when they could, anyway, to see if anything had changed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Caryl Hatzis, the voice of hope for many, began the transmission with her usual spiel: “This is an open broadcast from McKenzie Base, Sirius, to all UNESSPRO missions within range of this transmitter. Do not reply until you have read the entire contents of this message. We are the sole survivors of the human race, and we are united by the goal of rebuilding. Our primary task at the moment is to locate those colonies that have survived and been contacted by the alien race known as the Spinners. All life is precious. All resources are valuable. To ensure that nothing else is lost, we"), _c('i', [_vm._v(" must")]), _vm._v(" cooperate in this venture—even if it is to be our last.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There followed the standard introductions to new colonies that might have received the gifts but not been contacted by other survivors, warning them not to use their communicators except from their hole ships in positions well away from their home systems. After that, there was the plea to both Spinner and Starfish, requesting the opening of diplomatic channels as a matter of some urgency. Until either of the aliens talked to the humans whose paths they were so dramatically crossing, there was little the survivors could do to prevent the ongoing catastrophes. The long-term goal for all species was peaceful coexistence within human-surveyed space.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Attached to the message were data files containing the current state of the human survivor network. Alander glanced at it and saw that their last update had been included, along with data gathered from the fringes of surveyed space, where other missions were exploring. A handful of new Spinner drops were also highlighted. Starfish attacks were noted, too, as was their change of tactics, although not in any great detail. A careful perusal of the latest attacks suggested that three more systems had fallen to surprise invasions, one of them the mission found in Beta Hydras, the"), _c('i', [_vm._v(" Carl Sagan,")]), _vm._v(" yet there was no talk about evacuation. Alander wondered if Hatzis was trying to play down the new development in order to further her own plans or whether she genuinely wanted to avoid an overreaction.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Also embedded in the data was something intended specifically for them: “We have a message from Groombridge saying that the Spinners arrived two days after you left. The colony on Perendi did everything your messenger buoy told them to do, and everything went smoothly. Yesterday, though, they were buzzed by one of the anomalies and managed to capture an image. See for yourself, but I think it looks like one of our friends from Varuna.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The transmission carried a picture of a modified hole ship, its black cockpit encrusted with strange growths similar to barnacles or coral. It was shown silhouetted against the bright gold hull of one of the spindles, blurred as though in fast motion.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The message went on, “As usual, the anomaly departed when hailed, but not before giving the colonists a bit of a fright. They’ll keep an eye on the colony in 61 UMA to see if the Spinners or the anomalies go there next. Who knows? We might be able to get the jump on them, this time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And do what?” said Alander dubiously.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis didn’t reply; she was listening to the continuing message: “Peter, in your last report, you expressed a degree of uncertainty for the benefits of continuing your mission. But I’m asking you to seriously reconsider coming back too soon. We need scouts along the front—now more than ever, in fact. You are our closest agents to 61 Ursa Major and a possible Spinner/anomaly occupation. Please stay in the area for a while longer. If we do get any news, we may need to act quickly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("And that was that. There was nothing more he could do, unless he planned to hog-tie Thor and take command of"), _c('i', [_vm._v(" Pearl.")]), _vm._v(" He waited restlessly as she broadcast a brief reply to accompany the little information they had discovered on the system. When she had finished, he sat down beside her on the couch.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“So,” he said, “where to next?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You choose,” she said. Her mood was subdued and morose. “Somewhere nearby, though. I don’t want to be too long out of contact.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Yes,")]), _vm._v(" he thought,"), _c('i', [_vm._v(" mustn’t disobey orders.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I need a change,” she said. “All these systems are starting to look the same to me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He consulted the star chart in the hole ship’s memory and compared it against the UNESSPRO mission register. One name stood out. He changed the view to external cameras, then panned around until he had found the direction he was looking for.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“There,” he said, pointing to the brightest star in the sky. “That’s where I want to go.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Vega?” she said, frowning. “But there won’t be much to see. Any proplyd would have been dispersed long ago—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I know that,” he said. “And UNESSPRO knew that, too, but they sent a mission just the same. The truth seekers won out on this one, I guess.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She was about to say something, but he cut her off. “Anyway, that’s my decision, Caryl.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She shrugged. “Data is data, I guess.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Exactly,” he said. Then, not wanting to give her the chance to change her mind, he addressed the ship’s AI: “"), _c('i', [_vm._v("Pearl,")]), _vm._v(" take us to Vega, twice standard orbital insertion.” He didn’t know the habitable zones of a blue AOV variable, and he wasn’t about to take any chances. They were still unsure just how much punishment the hole ships could take. “Advise ETA.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Two point nine hours,” the AI reported. “External.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Okay,"), _c('i', [_vm._v(" Pearl")]), _vm._v(",” he said. “Do it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The screen went blank as the hole ship got under way. He turned to Hatzis next to him, wondering what she intended to do during the three-hour trip, and caught her staring vacantly toward the empty screen, her gaze lost somewhere between her and it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Are you all right?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She came to life, then, meeting his eyes. “What?” she asked distractedly. “Oh, I was just reviewing data.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Are you sure?” Even though he had known several incarnations of Caryl Hatzis, Alander found it hard sometimes to read the woman as an android. The muscles of the face were a profoundly complex and subtle barometer of personality; and the slightest change could have a profound effect. Half the time he didn’t recognize her at all, let alone know what she was thinking. Or when she was lying.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She stood. “I’ll be in my cabin.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Reviewing the data?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s right,” she said and walked from the cockpit.")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Alander came to get her before they relocated. ")]), _vm._v("He had"), _c('i'), _vm._v("spent the jump lying on the cockpit couch listening to a selection of music from various alien races, courtesy of the Gifts’ Library, piped directly to his ears from the hole ship’s AI. He wasn’t so much enjoying the unusual sounds as fascinated by how much they differed from what his own species regarded as music.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She opened her eyes when she noticed him watching her from the archway to her tiny cabin.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You look relaxed,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Just conserving my energy,” he said. It sounded better than"), _c('i', [_vm._v(" bored out of my mind.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She laughed lightly. “For what?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He shrugged. “Who knows what we might find in Vega?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It’s an astronomical curiosity at best,” she said. “We’ll be lucky if anything remains of the cloud it coalesced from.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He rolled his eyes and went back to the cockpit, calling over his shoulder: “We’ll be there in five minutes!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He was performing stretching exercises when she appeared. Sitting on the couch while he utilized the empty space behind her, she crossed her legs and waited.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The"), _c('i', [_vm._v(" Matthew Thornton")]), _vm._v(", wasn’t it?” he asked, fishing for conversation.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She nodded. “Registered as UNESSPRO six six six, believe it or not.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Really?” He hadn’t noticed that. “How would you feel getting"), _c('i', [_vm._v(" that")]), _vm._v(" mission?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Out of 1,000 missions, one of them had to have that number; 23 Bootis got unlucky thirteen. It doesn’t mean anything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He touched his toes. “Maybe the devil himself will be there to greet us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis didn’t comment. She just kept her attention fixed on the screen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Relocating,” said"), _c('i', [_vm._v(" Pearl.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Vega blossomed on the screen, a powerful blue white star with a highly variable output that peaked every three hours or so. Alander couldn’t tell if it was on an up- or downswing of its cycle, but was nonetheless impressed with its brightness. Hatzis had been right, of course: with that sort of energy blasting through the solar atmosphere, it was unlikely the cloud of gas it had condensed from would have been stable enough to form planets of any kind.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("But that doesn’t mean the system won’t be of interest, ")]), _vm._v("Alander mused silently as he viewed the various images the hole ship had taken in the seconds since its arrival. It was a thought that proved true more quickly than he could have imagined.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What’s this?” he said, unnecessarily taking a step closer to the wall screen. The image was of a tortured blob of gas off to one side of the star.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("Pearl")]), _vm._v(",” said Hatzis from the couch behind him, “zoom in on that feature.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What the hell is it?” asked Alander, taking a step back again as the image on the screen magnified.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It looks like a dust cloud,” said Hatzis. “Falling into the star against the solar wind.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It did have that look about it—like a sail collapsing slowly to the ground on a windy day. But there was a dense core that made him think it contained more than just gas.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And look there,” he said, indicating another image from a more distant part of the system. “Another one.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This blob had a definite solid core but still trailed a wispy cloud through the intense radiance of the star. It looked almost like a comet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Planetary fragment?” Hatzis suggested.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Perhaps.” He called up other images, touching the screen as though it were a manual keyboard. Even up close, the resolution was perfect. “Jupiter mass, maybe not native. A protostar with a solid core that drifted into the system and is being torn about by tides. Do you think it’s possible?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Possible, yes. Likely?” She shrugged. “I don’t know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Within five minutes, they found four more fragments of varying sizes and a spreading band of rubble that might have become an asteroid belt in an ordinary system. Here, the intense and variable solar wind was causing all sorts of havoc. The fragments were being blasted by radiation and particle winds more dense than anything the planets of Sol would have experienced, even during the worst solar storms. The larger fragment closer in was being blown apart by the wind as much as by the tides, while those farther out were in the process of losing significant percentages of their atmosphere every hour, hence the striking tails trailing away from the primary. Within a few decades, it would all be gone; Alander and Hatzis had timed their visit just right for a truly cosmic spectacle.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was only while studying the details of the rubble cloud that Alander noticed the tiny flashes of light winking and darting through the debris.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Do you see that,” he asked, “or are my eyes playing tricks on me?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This time, Hatzis got up to take a closer look at the expanded image. “Little ships,” she said breathlessly. “Fuck, Peter, there’s somebody here!” “But that’s not possible, surely? I mean, none of the other missions"), _c('i', [_vm._v(" built")]), _vm._v(" ships like that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Their eyes met for a second; she wasn’t alarmed yet, but she was ready to be. “Perhaps you should start broadcasting your hellos, now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Before she could open her mouth, an alert sounded.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Proximity alert,” said"), _c('i', [_vm._v(" Pearl,")]), _vm._v(" its voice even-toned but urgent.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Where?” Hatzis demanded.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The view changed to point at the sun, but there was nothing visible.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("Pearl,")]), _vm._v(" what the hell are we meant to be looking—?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Wait,” said Alander, taking her arm. “There!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("At the center of the star was a slightly different white from the rest of its surface, and the discolored patch was growing rapidly, spreading like a stain. It looked to Alander as though something impossibly white was rushing toward them. Or—")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The hole ship exploded out of the screen, perfectly white and perfectly spherical, completely visible only once it had grown larger than the star behind it. The smaller, black sphere of its cockpit spun around it like a bola, trailing sparkling motes in its wake.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Impact alert,”"), _c('i', [_vm._v(" Pearl")]), _vm._v(" warned.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Can we dodge it?” asked Hatzis, staring fixedly at the screen as the hole ship swelled to fill it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Taking evasive action,” said the AI."), _c('i', [_vm._v(" Pearl")]), _vm._v(" relocated, but not before a swarm of motes emitted by the attacking hole ship rattled across its hull. There was a sound like hail falling on a tin roof.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Are we damaged?” she asked, alarmed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But we were attacked?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“From the data available,” reported the AI, “the best answer to that question would be yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What the hell is going on?” said Hatzis to no one in particular. She was prowling anxiously around the couch, glancing at the screen in anticipation of them reentering real space. When they did, it was barely a kilometer away from their departure point, and the hostile hole ship was nowhere to be seen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("Pearl,")]), _vm._v(" broadcast the following message,” said Hatzis. “This is Caryl Hatzis of UNESSPRO Mission one five four hailing UNESSPRO Mission six six six. We are peaceful envoys representing the survivors of Sol system. Do you read me? I repeat: we are peaceful envoys representing the survivors of Sol system. Please cease all hostilities immediately, or—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The hole ship reappeared at frighteningly close quarters, emitting another wave of the sparkling darts. They struck with the same furious staccato as before but again did little more than cause the floor to vibrate beneath them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Or what?” asked Alander dryly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Before Hatzis could reply, the attack abruptly ceased. The attacking hole ship stopped dead before them, its midnight black cockpit orbiting rapidly around a pristine central sphere.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A male voice issued into the cockpit: “You’re human?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis’s jaw dropped open in surprise.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Of course we are,” Alander said. “What were you expecting?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was a pause that felt much longer than it actually was.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("Pearl")]), _vm._v(",” Alander said. “That transmission—it came from that hole ship, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Not as such,” was the reply—not from the AI, but from the male voice that had spoken before. “I’ve temporarily linked our ships—made them semi-independent nodes of the same mind, if you like. That makes it easier to communicate.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“How—?” Hatzis started.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Hole ships have the ability to cross-talk when sufficiently close. You didn’t know they could do this?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No. Who"), _c('i', [_vm._v(" are")]), _vm._v(" you?” she asked, looking around the cockpit as if the answer to her confusion might be found there. “And how the hell do"), _c('i', [_vm._v(" you")]), _vm._v(" know?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The name’s Axford,” he answered. The voice held a mixture of amusement and challenge. “General Francis T. Axford. And now’s not the time to stand around chatting. Even if you hadn’t just told me, I’d know where you came from. Only a bunch of incompetent scientists like you would go about things in such a crazy, half-assed fashion.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander’s memory worked furiously. The name rang a bell, but it wasn’t on any of the mission registers he had memorized, and he didn’t recall a ranking general qualifying for the survey program. All the military officers were trained for administrative command. Unless...")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Frank the Ax?” he asked incredulously.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The man let out a low chuckle. “My reputation clearly precedes me,” he said. “Or outlived me, depending on how you look at it. Either way, I’m—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But you can’t be,” Alander cut in again. “It’s not possible.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Can be, is, and I am,” said the man. “Listen, I don’t particularly like sitting around in the open for long, so if you want to continue this conversation, then I suggest we go somewhere less conspicuous.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Where exactly would that be?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Your hole ship has the coordinates, Dr. Alander,” said Axford. “I can’t actually command its guidance system, but I can tell it where to go. Just give the word, and it will take you there. Don’t bother asking it for the exact destination, because I’ve already instructed it not to tell you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander frowned. “Wait a minute. How did you know that I was—?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Your expression. Like I said, the ships can cross-talk,” he replied with obvious irritability. “They can exchange data. But I haven’t got time for this right now, people. If you want to talk, then you’ve got to instruct your ship to follow me in.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("Where")]), _vm._v("?” said Hatzis.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Hermes Base,” he said. “My headquarters. Can’t you see it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Both looked simultaneously at the hellish solar vista on the screen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No,” said Alander after a moment.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Good,” said Axford. “That’s just the way I like it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("1.1.4")])])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_c('i')])])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("It took some convincing to get Hatzis to follow the")]), _vm._v(" ex-general after the hole ship on the wall screen disappeared. Alander appreciated her apprehensions (making a blind jump into God only knew where, he said, didn’t much appeal to him, either), but he argued that the presence of the hole ship indicated that there had been a Spinner drop, and they should find out what they could about it—especially given the fact that nowhere else in the system had they found any evidence of the Gifts. There were no normal planets around which to anchor orbital towers, so they must have used a new design. At least in systems containing alternate gift configurations, the Spinners had had a solid planet to work with. But it was the presence of Axford—former military cost cutter, then senior financial advisor to UNESSPRO—that seemed the greatest lure for Alander. Everyone who had argued for funding prior to launch had crossed swords with him, usually to their loss. There had long been rumors about shady deals and favoritism—but Axford had never been on the survey team register. He hadn’t been at entrainment camp. There was no way Hatzis could think of that could have brought Frank the Ax to Vega. Alander, of course, had to hear the explanation.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It’d be criminal not to,” he said. “We have to know what he’s doing here—and how he knew about the hole ships merging. And the weapon systems he has...” He stopped, waved his hands as though lost for words. “The system is a Spinner drop,” he said instead. “We’re obliged to make contact.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("That was an argument she could accept, if not wholeheartedly."), _c('i'), _vm._v("“"), _c('i', [_vm._v("Pearl,")]), _vm._v(" you have a destination?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes, Caryl.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Can you tell us where it is?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I have been instructed not to.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She shook her head, resigning herself to the fact that she couldn’t leave in good conscience. “Take us there, then.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Barely a minute later, they relocated in hell.")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Light of every frequency assailed the hole ship. ")]), _vm._v("Giant upwellings of gas or liquid—Hatzis couldn’t tell which— circulated around her with surprising turns of speed. If the information Axford provided was accurate, then the scale of what she was seeing was enormous. And while she didn’t believe everything he said, she was sure he had no reason to lie about this.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hermes Base was"), _c('i', [_vm._v(" inside")]), _vm._v(" the largest planetary fragment, close in to the pounding brightness of Vega. Its immediate surroundings consisted of a turbulent mix of elements, stirred by the tides and its own internal collapse. Torn between coalescing into a new planetoid and breaking apart altogether, it seemed the most unlikely place in which anyone would ever consider hiding a base. Which was exactly why Francis Axford had chosen it, she imagined.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She and Alander followed him via conSense deep into the fragment’s churning interior, letting him take her on a sightseeing tour designed more to impress than to actually inform. Hermes Base turned out to be not so much a base as a distributed network of work points that combined to perform all the functions of something more rigid. Parts failed constantly, but there were so many replacements at hand, and more constantly being built by nanomachines, that the loss was barely noticed. The fierce melting pot of the fragment was a rich source of elements and energy for the manufacturing process.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ve been here over seventy years,” Axford was saying as he showed them around. His image was of a slight, gray-haired man dressed in a loose-fitting black suit, with a lined face that belonged to someone’s grandfather, not a high-echelon hatchet man. “Seventy years; remember that. I had all of this in place long before the Spinners arrived.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And when was that, General?” asked Alander.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Two weeks ago,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Seventy years")]), _vm._v(", Hatzis thought, "), _c('i', [_vm._v("and not a trace of senescence")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What happened to the crew?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("‘They never even made it on board,” he answered. “It was all faked. We made it look like the"), _c('i', [_vm._v(" Thornton")]), _vm._v(" left with a full complement, but there was no one else aboard except me and the others, and I soon got rid of them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The offhand manner in which he spoke about killing sickened Hatzis. “You make it sound as if you did little more than delete some unwanted data.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He laughed at this. “Well, it could hardly be regarded as murder,” he said. “They were only copies, after all. Look, this was a one-man mission from the start; that was the way I’d originally intended it, and I indulged attempts to change my mind only as a temporary measure.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“So you’re basically a stowaway and a mutineer, is that it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He laughed again. “Absolutely,” he said. “But I prefer to think of it in terms of expediency. We were all in this for ourselves. I just acted first.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Who"), _c('i', [_vm._v(" were")]), _vm._v(" the others?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Entrainment techs, policy makers, a senior ministerial aide, a dozen or so people from within UNESSPRO itself. No names. I needed them to get me aboard the program. After that, they were irrelevant. One ship was all I asked for, and that’s what they gave me. It didn’t matter"), _c('i', [_vm._v(" where ")]), _vm._v("I was going; I just wanted to get out before the Spike hit.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You saw it coming?” asked Alander from the hole ship. Still unable to withstand conSense for too long, he was following their progress by less intrusive means.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Everyone with eyes did,” said Axford drolly. “It’s just that no one knew what to do about it. That’s partly why UNESSPRO was founded, you know: to get"), _c('i', [_vm._v(" something ")]), _vm._v("out before the crunch came. But there was only so much we could slip past the serious science payloads. A few missions out of the thousand aren’t what they appear to be. Don’t ask me which ones, because I don’t honestly know; the idea was to keep them secret so no one or no "), _c('i', [_vm._v("thing")]), _vm._v(" could follow. If the others survived their journeys, they’ll be working out what to do next, just like me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis thought of the anomalies seen by such colonies as Perendi in Groombridge 1830. Everyone had assumed that they were of alien origin. Now she wondered whether they could be the work of one of these pre-Spike human outposts. But she doubted it. The first had appeared in the very early days, when only a few Spinner drops had been recorded. That didn’t give anyone enough time to find and modify hole ships in the way that had been observed, and it still left the motive behind the death markers hanging.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“This is what I wanted to show you,” murmured Axford. They zoomed through an incomprehensibly large gobbet of molten rock and into a startlingly clear space. “This is my hangar, if you like,” he explained. “I keep "), _c('i', [_vm._v("Mercury,")]), _vm._v(" my hole ship, here. Before that, it was a materials repository. The walls are reinforced with a flexible membrane designed to bend with the pressure but not burst. No matter what shape the space within assumes, it’s perfectly safe.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Six golden structures occupied the center of the bubble, linked together and anchored to the walls by delicate-looking strands of black material. There was no doubt they were essentially the same as the gifts found elsewhere in surveyed space, different from the others only as a result of their different environment. Their shapes were just as intricate and mysterious, and Hatzis was sure that the contents would have been the same also.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You’re telling us that"), _c('i', [_vm._v(" you")]), _vm._v(" built this place, not the Spinners?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You don’t have to sound so surprised,” he said with a smile. “Seventy years is a long time, and I didn’t have to put up with interdepartmental arguments to get things done. If I wanted to do something, I just did it. End of story. I actually started redesigning the"), _c('i', [_vm._v(" Thornton")]), _vm._v(" in transit. By the time I arrived, I had patterns for fifty of myself ready to transfer into hardware. The first thing to do was find raw material and exploitable energy—and as you can see, Vega has plenty of both. Within a year, all fifty of me were running at triple time, all following the same agenda: better, more, faster. I mass-produced probes, mining vessels, and processors to run them all. I seeded myself everywhere to avoid catastrophic breakdowns. I burrowed into the planetary fragments to diversify as much as possible. Vega is pretty volatile, and even down here, I’ve had problems. But it’s nothing I can’t recover from. I’m spread far and deep enough to bounce back from almost anything. Got three bases now: Hermes, Apollo, and Terpsichore. I hope you won’t take offense if I don’t tell you where the other two are.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You’re the contact, then,” said Alander. “The Spinners chose you when they came?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“There was no one else to choose from,” said Axford with a sly grin. “They had to talk to me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis shook her head, still trying to come to terms with what Axford was telling them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“So you’re a group mind?” she said. “A gestalt?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Absolutely not,” he said indignantly. “They’re all me. I don’t want to be anything I’m not. That’s the surest way of losing control.” His expression sobered. “That’s how I noticed the old-age problem, you know. It showed up very early on because I was fast-tracking. My earliest copies started to behave improperly. The later ones worked out what was going on and erased the corrupted ones, the failures. Kept the memories, of course, and installed them in fresher copies, so I haven’t lost anything. We’re a team, here, and we don’t tolerate weak links.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("They paused in their wild flight around the gifts long enough for Axford to lean in closer to Hatzis and to part his hair, revealing a numeric tattoo on his scalp.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s my iteration number,” he said. “One thousand twenty-second Francis T. Axford to roll off the production line. You can have any color, as long as its blood is pure.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But you’re—” Hatzis started, but was quickly cut off by Axford.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m talking metaphorically here, Caryl,” he said in a tone that suggested he was disappointed he’d had to point this out. “And I’m not racist, either, in case you’re wondering. The only ideal I believe in is"), _c('i', [_vm._v(" me")]), _vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("So I see,")]), _vm._v(" she thought.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What are your long-term plans?” asked Alander.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford smiled innocently, as if to say,"), _c('i', [_vm._v(" What makes you think I have a plan?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“To survive, of course,” he said. “Isn’t that what everyone wants?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes, but not everyone uses the same methods,” said Alander.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford laughed. “You’re wondering if I’m going to stay put here in my little pocket of space, is that it? Or whether I might burst out of here like a cancer and spread like a contagion across your own region of space.” His smile widened. “I’m tempted, you know, just to see your reaction. And how you would deal with something like that. If you handle me as badly as you’re handling the bug-eyed monsters, I’d be all over you within a decade.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What does that mean?” asked Hatzis.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Ever since I turned on my communicator, I’ve been listening in on your broadcasts. How you guys have managed to last as long as you have is beyond me. They’re slaughtering you out there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“So, how"), _c('i', [_vm._v(" should")]), _vm._v(" we be handling this, then?” said Hatzis with irritation. His smugness was rapidly starting to piss her off.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Frank Axford didn’t answer straightaway. Instead, their inward plummet came to a halt—or seemed to, anyway. The journey had been entirely conSense-generated; Hatzis’s body was still in"), _c('i', [_vm._v(" Pearl,")]), _vm._v(" sitting on the couch. The hole ship itself was docked next to Axford’s"), _c('i', [_vm._v(" Mercury")]), _vm._v(" in the very bubble they had just reached, virtually.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The illusion folded around them, became a spare, gunmetal-gray room, as bare of personality as an interrogation room, with two aluminum chairs for them to sit on and a 3-D tank for Alander. Axford’s physical presence was slight compared to Hatzis’s artificial body, but his personality more than made up for that.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“To start with,” he said, “the Spinners gave you gifts, which you have used to blithely announce your presence to all and sundry throughout the galaxy. You might just as well have sent a message saying, ‘Here we are, please come and get us.’ It was the stupidest thing you could have done.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We’ve been extremely cautious with the messages we’ve been sending out lately,” Hatzis said, defending Sol automatically.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yeah, but only after you had your butts kicked a couple of times,” Axford shot back. “And look at the cost of your recklessness! Those Spinner installations are enormously valuable—more valuable than the colonies, if you want my opinion. Humans can be copied; the gifts can’t. What’s the current estimate of the leading edge of the Spinner migration, 61 Ursa Major? At that rate, they’ll be gone in weeks. And once they’re gone, it seems pretty clear that they’re not going to be coming back. If we lose what we have, that’s it. Mommy’s not going to take pity on us if we drop our ice cream in the dirt, no matter how unfair we think they’re being.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The BEMs you call the Starfish don’t care about us, either. And they’re not stupid. For whatever reason, they want us gone—totally and unequivocally"), _c('i', [_vm._v(" gone.")]), _vm._v(" They don’t even wait anymore for your invites; they’re actively seeking us out, and"), _c('i', [_vm._v(" that’s")]), _vm._v(" a scary notion. These are superintelligent beings, remember. It’s not like they’re going to miss a system here and there. They are not going to stop until we’ve been eradicated from every single system. Yet you guys jaunt about surveyed space like you’re on some divine mission and don’t do a goddamn thing about it! You’re ignoring the real problem, and until you "), _c('i', [_vm._v("face")]), _vm._v(" that problem, it’s just going to keep coming back and biting you on the ass.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis did her best to keep a lid on a rising tide of resentment. “So what’s your solution? Wait it out? Hide while everyone else suffers? Great scheme, Frank.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Hey, don’t knock it, lady,” said Axford with a smile. “It sure beats sitting around like ducks and painting little targets on yourselves. Besides, I’m talking to you now, aren’t I?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And we’re listening,” said Alander, casting a cautionary glance in Hatzis’s direction. Axford’s chair creaked as he sank back into it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Okay, good, because I have an opinion I’d like to share with you. I think you’re wasting valuable opportunities—or at least you"), _c('i', [_vm._v(" seem")]), _vm._v(" to be, if the information in your broadcasts is anything to go by. None of you are treating the situation as a military threat, which is precisely what this"), _c('i', [_vm._v(" is.")]), _vm._v(" And until you do, you’re always going to be at a disadvantage.” Glancing over to her, he quickly added, “I’m sorry, Caryl, but it’s true.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was his tone that bothered her more than anything else, she decided, and not necessarily what he was actually saying.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Go on,” she forced herself to say.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Okay,” he said, shifting his position to fully face her. “Look again at the Spinners; bug-eyed monsters number one.” An image of the drop in Vega appeared behind him, rotating to highlight key points as he spoke. “Ten obvious gifts, among them a communicator, a hole ship, a library, an art gallery, a map, a surgery, a science hall, and a materials lab. The hardware makes up the rest of the gifts: the Gifts themselves, a machine for making the skyhook cables, the instantaneous transport system. But what’s all this stuff"), _c('i', [_vm._v(" for")]), _vm._v("? What’s it supposed to teach us? Judging by your transmissions, you lot look at it and see knowledge for its own sake. You search the library for answers to questions, rather than solutions to problems.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But the Gifts don’t know anything about the Starfish,” she protested. “We’ve already asked.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“A number of times, actually,” Alander added.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“As did I,” said Axford. “But that doesn’t mean they "), _c('i', [_vm._v("can’t")]), _vm._v(" help. Look.” He leaned forward. “Me, I’m an old army man, right? I’ve been trained to think certain ways. That makes me one-eyed and obsessive, agreed, but it also gives me a tremendous focus in situations like this. Whether you like it or not, this"), _c('i', [_vm._v(" is")]), _vm._v(" a military situation, and it needs a military mind to cut through it. When I look at the hole ship, I don’t see a convenient means to contact neighbors and issue invitations; I see a scout vessel that is superbly designed for covert operations. When I browse the materials lab, it’s not to marvel at strange forms of matter and energy we barely suspected existed; I’m looking for something as hard as the spindle hulls, just in case we ever need to get through one of them. And when I search the library, it’s not for information on alien cultures or the black hole at the center of the Milky Way; it’s for anything I can use to throw at the enemy, whoever they are and whenever they come. Because, believe me, they "), _c('i', [_vm._v("will")]), _vm._v(" come. And when they do, I want to be as ready for them as humanly possible.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Something like revulsion rushed through her. “You’re using the gifts as weapons?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Absolutely,” he said without shame or apology. “Where did you think I got that trick with the darts I used on you when you arrived here? It didn’t work, but it might have. Give me another day, and I’ll have something else. There are hundreds of me working simultaneously on this: researching, building, testing. Laser batteries I already have—in fact, I’ve had them since 2080, just in case something came this way after the Spike. In a week, I’ll replace them with something much more powerful. Something, maybe, to make the next visitors I get think twice about staying.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You can’t really think that fighting the Starfish will work,” said Hatzis.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m not talking about the Starfish right now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Then who"), _c('i', [_vm._v(" are")]), _vm._v(" you talking about? One of the other colonies?” she said. “You’re in contact with someone else?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“He’s not talking about the other colonists,” said Alander, a look of realization on his face. “Tell me, General, just who exactly did you think we were when you attacked us earlier?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Exactly?” said Axford. “That I don’t know. Do you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What the hell are you two talking about?” Hatzis asked irritably.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The anomalies,” Alander answered. Then, to Axford: “If we’re talking about the same thing, then yes, we’ve seen them—but we have no idea who or what they might be. We think they leave artifacts behind in systems that have been destroyed by the Starfish.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And they’ve been here?” Hatzis asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Frank the Axe nodded. “Even tried to take my gifts,” he said. “They didn’t manage it, of course, but I thought they might try again—maybe even come back with reinforcements. Then you two appeared. I was better prepared this time. You were lucky I called off the attack when I did.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You"), _c('i', [_vm._v(" fought")]), _vm._v(" them?” Hatzis exclaimed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I had to,” said Axford. “The bastards were trying to take what was mine. Just because I was lying low, waiting to see what they were, they thought I wouldn’t be able to resist. But they were wrong. I don’t like people who prey on the weak.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis wondered if there was anyone Axford"), _c('i', [_vm._v(" did")]), _vm._v(" like.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Would we be able to look at your data on their hole ships?” Alander asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ll do one better than that,” said Axford, the sly grin returning. “I can even let you take a look at the sample I managed to capture.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("1.1.5")])])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_c('i')])])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("The hole ship looked little different than any other. ")]), _vm._v("It appeared in the far reaches of the system, hung there for a second as though looking around, then relocated closer in. A twisted, strangely modified cockpit issued from its side, orbiting in a disconcerting ever-changing fashion. It radiated an air of readiness, like a fencer shifting restlessly, with sword upraised.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then it moved. With no noticeable emissions, it went from standing still to blurring motion in less than a second. The image wobbled as its source tried to keep the hole ship in view. It failed just as the craft’s destination came into view: a blue black world under a yellow sun.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Impressive,” said Alander. “We’ve been looking for attitude controls in the ones we have.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You won’t find them,” said Axford, freezing the view. “They have to be added. But it isn’t as difficult as you might think. The hole ships actually have an inertialess switch you can activate to make it easier to push them around. Although I’m guessing you haven’t found that, either?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander nodded. There was no point lying. One look at"), _c('i', [_vm._v(" Pearl")]), _vm._v(" would have told Axford that already.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Where was this footage taken?” asked Hatzis.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Van Maanen 2,” said Axford. “One of the inner systems; not far from your McKenzie Base, in fact—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I know it,” said Hatzis. “We’ve been there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander didn’t correct her. He and her"), _c('i', [_vm._v(" original")]), _vm._v(" had been there in the very early days, when scouting for a location for their headquarters, but this version of Hatzis never had. Van Maanen 2 was a dwarf G-type star not far from Tau Ceti and Sirius.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The mission was dead,” Alander elaborated. “But we left a beacon in case someone else came through.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“They did.” Axford switched to another image. This one showed the same planet but from another position. In the foreground was one of the golden spindles left by the Spinners. “The usual configuration,” Axford went on. “Ten towers, ten installations, one orbital ring. They must have revived someone to act as contact. From your reports I’ve listened in on, I gather they do this sometimes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“They do,” said Hatzis. “We’ve had the occasional response from colonies given up for dead. Not this one, though.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No, you wouldn’t have.” Another image, another point of view. This one showed an orbital installation of human origin. “This is what they turned their ship into.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The"), _c('i', [_vm._v(" Steven Weinberg")]), _vm._v(",” Hatzis supplied.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“As you no doubt saw, they were busy before they died out,” said Axford. “But they died out just the same. Watch.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The strange hole ship flashed into view, heading on an apparent collision course with the human installation. A split second before impact, however, it vanished.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“See? The hole ship was trying to get a reaction from the colonists, to see if anyone was home.” The recording continued behind Axford’s narration. “Clearly, they got no response. For whatever reason, whoever was in there wasn’t paying attention. So the hole ship comes back....” The hole ship appeared again, no longer moving aggressively but jockeying to dock with the station.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“How come they ignored"), _c('i', [_vm._v(" you")]), _vm._v("?” asked Hatzis.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I was lying low,” explained Axford. Then, seeing their blank expressions, he laughed out loud. “You haven’t even worked"), _c('i', [_vm._v(" that")]), _vm._v(" out yet? Ha! I swear, it’s a miracle you lot have survived as long as you have.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis was clearly about to respond to this when Axford continued with: “Your hole ship doesn’t have to arrive completely at its destination before you can start looking around. You can be half in, half out of real space, and the sensors will work. When you’re in that state, your profile is reduced to about thirty percent. You can’t move, but it’s handy if you just want to check things out without being seen.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander turned back to the display, more reassured than ever that they stood to learn a lot from Frank the Ax. He watched in fascination as the hole ship’s modified cockpit managed to attach itself to the installation. The point it had chosen to adhere to wasn’t an airlock, however. The coral-like growths surrounding the cockpit seemed to reach out with droplets or tentacles to adhere to the installation’s exterior, anchoring fast to the metal and carbon.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Looks like they’re getting ready to tow, doesn’t it?” said Axford.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It did, Alander thought. The cockpit retreated until it was close to the larger, central part of the hole ship and stopped rotating. There was a moment of stillness in which he imagined the alien machine muscles flexing in readiness, then—")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Bang,” said Axford softly as the hole ship vanished altogether, taking a sizable chunk of the installation with it. The remains shuddered violently, losing their center of gravity and almost disappearing for a second in a bright gust of frozen air. Then it was tumbling, dead, through its orbit around the planet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The image froze as Axford spoke again. “It took them six trips to take the lot of it,” he said. “By then, of course, someone"), _c('i', [_vm._v(" had")]), _vm._v(" noticed. There was some ground activity; a satellite changed orbit in order to get a better look. But there wasn’t much they could do. Whoever the contact was, they clearly didn’t have time to get into the spindles and explore the gifts. The Roaches timed it perfectly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Roaches?” asked Alander, turning away from the screen to face Axford.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The ex-general shrugged. ‘That’s what I call them, anyway,” he said. “Because they scavenge, just like cockroaches.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You think that’s what they were doing?” asked Hatzis. “Scavenging?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Absolutely,” said Axford. “When the main installation was gone, the hole ship came back to pick off a few of the larger pieces of junk floating around in orbit. Then they started stripping the gifts themselves. One thing you may have noticed about them is that they’re not terribly reducible. You can’t take them apart; you can only remove their contents—and then only in places. Your Immortality Suits, for example, are transportable, as are some of the safer materials in the Lab. The art in the Gallery is as well, obviously, but then I personally wouldn’t waste my time with such stuff—and from what I’ve seen, I don’t think the Roaches are overly concerned about it, either. They focus on the things that are practical. Things they can"), _c('i', [_vm._v(" use.")]), _vm._v(" And to that end, the biggest prize is, of course, the hole ships.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He indicated the new image display before them. It showed two bright circles moving in tandem across the planet and vanishing at the same time.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“They took it,” said Hatzis, staring at the screen with her eyes wide. “No wonder we didn’t hear from the colony. They would’ve listened to the beacon we left and known—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Don’t be so naïve,” Axford cut in quickly. “The beacon was the first thing the Roaches took out. Whether or not your contact on the planet had the time or the brains to listen to it beforehand, we’ll never know. As the Roaches left, they signaled the Starfish.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford seemed to be enjoying her reaction. “Within a day, all evidence was gone,” he said, nodding. “Listen to this.” A sound like two bells colliding rang through them. “That’s the transmission I picked up through the hole ship just before they left. Sound familiar?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It sounds like a transmission we picked up in Upsilon Aquarius,” said Alander, “when we were testing the communicator for the first time. After a couple of primary transmissions, we received something in reply, but at the time, we just thought it was just noise or some sort of reflection.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“There have been several such pulses recorded,” said Hatzis. “We ignored them for the same reasons. They don’t seem to contain any information.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The Roaches are sending them,” said Axford. “I mean, who else could it be? If they were reflections, we would’ve heard more of them. If it was just noise, the hole ships would have filtered it out. There’s no evidence to suggest that the Spinners or the Starfish use this means of communication. And why would they, when there’s no way of choosing who you talk to? I’m guessing that such a means of communication would be too primitive for intelligences as advanced as they seem to be. No, these transmissions don’t contain any information because they don’t"), _c('i', [_vm._v(" need")]), _vm._v(" to. They just need to be heard.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And you’re that confident it’s the Roaches?” said Alander.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Nothing else make sense,” said Axford. “It"), _c('i', [_vm._v(" has")]), _vm._v(" to be them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Those sons of bitches,” said Hatzis. Even in conSense, her face was pale. “They’re sending entire colonies to their deaths!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander nodded, although he preferred to defer his moral judgment until he had more information. “This would mean they’ve been active since before Adrasteia was destroyed,” he said. “There must have been other systems they’ve approached for us to have heard their bait signals.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Exactly,” put in Axford. “Who knows how many systems these scabs attacked before you started to get your shit together? Now it’s harder for them because you have some vague organization up and running. There are fewer cracks for them to slip through. Even without me to help you, you might eventually have noticed them. And then where would they be? My guess is they don’t like to fight if they can avoid it, otherwise they wouldn’t be skulking around like this, letting the Starfish do their dirty work.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Parasites,” Hatzis spat. “They’re nothing more than fucking parasites.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("“Intelligent")]), _vm._v(" parasites,” Alander said. “Let’s not forget that. They’ve worked out how to modify the hole ships. They look different, behave differently. It’d be foolish to write them off completely.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I agree,” said Axford. “When they came here, I stayed hidden, thinking they’d move elsewhere. But they detected the gifts somehow and came in here to get them. The element of surprise only lasted so long. Before they came, I’d have bet good money that no one would get out of here if I didn’t want them to, but they"), _c('i', [_vm._v(" almost")]), _vm._v(" managed. It was too close for my liking.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What happened?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford smiled. “Now, now, Dr. Alander,” he chided playfully. “I’d be a fool to let you know exactly what I’m capable of, wouldn’t I? Let’s just say there’s one less Roach ship to worry about, shall we?” He faced Hatzis. “You like the sound of that, Caryl? Does that appeal to your all-for-one moral code?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She looked uncertain for a moment. “I don’t approve of violence, if that’s what you’re wondering.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford rolled his eyes. “I don’t give squat for your approval, Hatzis,” he said. “I did you a favor, narrowed the odds a little. Can’t you be pragmatic enough to at least acknowledge that? Would a small display of gratitude be too much of a stretch for you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She glared at him as though thanks was the farthest thing from her mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You two deserve each other, you know,” said Alander wearily. And they did: multiple bodies, long-term agendas for the human race, definite ideas about morality and their place in the universe.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis turned her glare on him, then returned to Axford. “What about this sample you said you had? Are you ever going to show it to us?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That depends on what’s it worth to you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh, for fuck’s sake.” Hatzis stood. “Do we have to put up with this bullshit?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander indicated that she should sit back down. “What exactly do you want?” he asked Frank the Ax.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“An ally,” was the simple and surprising reply.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Someone else you can sacrifice when you no longer need them?” Hatzis snapped. “Forget it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Not this time,” Axford returned evenly. To Alander, he explained, “Look, if the Starfish really"), _c('i', [_vm._v(" are")]), _vm._v(" going from system to system now, then I’m not safe here anymore. If the Roaches could find my gifts without any problems whatsoever, then I’m guessing that the big players in this game will be able to as well. I need a contingency plan. I need more resources. Ideally I’d like another hole ship— or a whole fleet of them, preferably—but I’m not likely to find one on my own. So I need allies. Specifically, I need someone to help me do something—something I think you might be interested in.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And you think we should put our differences aside so we can work out a trade?” said Hatzis.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford nodded, ignoring the sarcasm in her tone. “I’ll give you what information I have on the Roaches in exchange for your help.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis looked like she was about ready to leave, just to deny him, but Alander couldn’t let that happen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, we can’t deny that we need that information,” he said. “So unless you’re planning to do something we can’t agree to, then I think you’ve got a deal.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis’s face settled into a mask of distaste, and he knew she understood. They"), _c('i', [_vm._v(" did")]), _vm._v(" need what Axford had; there could be no denying that. Besides, she must have realized that Alander had saved her from making the decision herself, so if anything went wrong, the option of blaming him would always be open to her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I want something more substantial than promises to share information,” she said. “What about this sample you’ve been promising to show us? Is it a piece of one of their hole ships or something?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh, much better than that, Caryl.” His smile was wide and predatory. “Hole ships don’t blow up, you see. They dissolve like they’re made of nothing but air, piece by piece. When you hit one hard enough, when they die, everything on the inside spills out—and if you’re careful, or lucky like I was, you can time it just right to make sure none of it gets damaged.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander glanced at Hatzis and saw understanding dawn in her eyes, but it was he who managed to speak first. “You caught one of their"), _c('i', [_vm._v(" bodies")]), _vm._v("?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Even better than that.” The view of conSense before Alander began to darken as Axford talked. “Remember, they have access to Spinner technology, just like us. They have hole ships and ftl communicators. In fact, they probably use the libraries to locate suitable stars for our colonies and scout them until the Spinners appear. I’m sure they dipped into the library as I have, seeking new ways to modify their hole ships. But more importantly for us at the moment, they have—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I-suits,” finished Alander, staring at the figure materializing before them in the darkness.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford didn’t try to hide his pleasure. “Caryl Hatzis, Dr. Peter Alander, I’d like you to meet my guest, the first alien I’ve ever had the good fortune to meet in person. I call him Charlie. You’ll have to forgive him if he isn’t very talkative, though; he really hasn’t been himself since he arrived. In fact, I think he might even be dying.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander stared in amazement at the gangly, frail looking alien that appeared on the screen. A long silence ensued as neither he nor Hatzis could speak, and it was only broken when Axford glibly muttered, “I don’t suppose either of you would have any idea what these bastards might like to eat, by any chance?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("The alien was, to all intents and purposes, right there in ")]), _vm._v("front of Alander: living, breathing, solid, but as motionless as a stuffed museum exhibit. He didn’t doubt for a second that it was real. After all, what would it benefit Axford to fake something like that? It was too important, too critical a moment in the evolution of humanity. Not even someone like Frank the Ax would invent something like"), _c('i', [_vm._v(" this")]), _vm._v("—although there was little doubt that he would use it to his advantage.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But that didn’t matter to Alander right then. At last, after many frustrating weeks of dealing with the nebulous Spinners and Starfish, here was a creature he could actually"), _c('i', [_vm._v(" touch.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The image rotated so he could see it from all angles. That Charlie was a biped was immediately obvious, but its proportions were all wrong. Its legs were much longer than a human’s, compared to its trunk; long, tapering shins flared upward past the knees into enormously strong-looking, triangular thighs. The knees were bent so it looked like it was crouching. Its trunk was barrel-shaped, almost literally a cylinder, with strange, pouchlike folds and flaps in waxy, gray green skin. Partially hanging from this was a coarse-looking vest, while covering upper parts of its legs was a kilt fashioned from the same material. Alander assumed that the garments were decorative, as they offered no real protection. Much like his own, beneath the I-suit.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The creature’s forward-mounted arms were folded protectively across its chest, rising and falling with every rapid breath—the only movement Alander could discern. The hands were small and thin, and had several digits sprouting from each, but it was unclear how many there were or how precisely they were jointed. Two flat plates extended from its back."), _c('i', [_vm._v(" Vestigial wings?")]), _vm._v(" Alander wondered. They were more like an insect’s wings than a bird’s, or the sheaths that might once have covered them, at least.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When the image rotated around to the front again, its face captured his full attention. The head was roughly the same shape as a biscuit barrel and seemed smooth all over. There were no obvious protuberances. Instead, it had a marked pattern of pigmentation across its face: stark black lines with a perfect vertical symmetry that reminded Alander of a Rorschach blob. The line of symmetry gave the face a protonose; on either side were blobs that might have been eyes, nostrils, and ears, while a line that stretched from one side to the other could have been a mouth. It was impossible to be certain. For all he knew, the alien could have been wearing a helmet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“He’s an odd-looking fellow, don’t you think?” said Axford. “I ran him through the gifts when I picked him up, but there’s only so much you can tell without invasive surgery. We’ll have to wait for him to die before we can do that, I guess.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander caught Hatzis’s look of disgust at Axford’s comment, but she didn’t say anything. She was probably as much in awe of what she was seeing as Alander and wouldn’t spoil it by arguing with Axford.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“His biology is very complicated,” Frank the Ax was saying. “Some of it might even be enhanced by nanotech or implants. He has analogs of cells and DNA and blood and stuff, but it’s all slightly skewed. His genes have six bases, for instance, and his blood is sort of yellow.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Do the Gifts recognize his species?” Alander asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No, they don’t,” he said, frowning. “And I find that a bit odd, actually. Either the Spinners deliberately kept him and his kind out of the library, or the Roaches themselves wanted to be kept out of it for some reason. For all we know, he could be a renegade Spinner stealing back some of the booty.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander nodded thoughtfully. It was an interesting suggestion. If there were factions within the Spinner race, then maybe they weren’t as all-powerful and mysterious as once thought. In fact, they might be no different than humans.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Where are you keeping him?” asked Hatzis.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“In the hole ship. The"), _c('i', [_vm._v(" Mercury")]), _vm._v(" has set up an isolated environment for him, based on what we picked up in the surgery, and is keeping him relatively safe. It’s not perfect, but the I-suit is doing the rest. For now, anyway. I’m not sure how much longer he’s going to last. I think he might be in a coma.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You keep saying ‘he,’ “ interrupted Hatzis. “You’re sure that’s its gender?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Take a look for yourself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A series of anatomical images flashed against the darkness behind the alien, settling after a few seconds on a close-up of the creature’s genital area.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("Two")]), _vm._v("..."), _c('i', [_vm._v(" ?")]), _vm._v("” Hatzis was clearly as amazed as Alander.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Like snakes,” said Axford. “Whoever these guys are, they take symmetry to the extreme.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What about communicating with him?” Alander asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I tried,” he said, nodding to the image display. “See what you can make of it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("More footage appeared. In it, the alien was awake and active, restrained in a small room. It was pacing backward and forward, its legs moving with a disturbingly jerky gait that left no doubt in Alander’s mind that it wasn’t human. "), _c('i', [_vm._v("A person in a suit pretending to be an alien couldn’t move like that,")]), _vm._v(" he told himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was clearly agitated. The wing sheaths growing from its back flexed and snapped. This, combined with its long, angular legs and relatively short arms, reminded Alander of a giant grasshopper. But the creature was clearly warm-blooded, and it lacked the carapace, compound eyes, and mandibles of an insect.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Its face was the most startling thing. Transformed from a lifeless biscuit barrel, it was almost unnaturally mobile. Muscles under the skin flexed the patterns of pigmentation into new shapes, breaking the symmetry then re-forming it with unnerving speed. Its eyes, opened, revealed glassy orbs with internal lenses that constantly changed position, like the inside of an antique camera. Its mouth was the slit he’d identified earlier, but it wasn’t that of a lifeless dummy. It was extraordinarily mobile, opening and shutting in shapes that had no parallel on a human face. Behind narrow lips Alander glimpsed a yellowish tongue and two rows of protrusions that might have been teeth. And its voice...")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander put his hands over his ears when Axford cranked up the volume. It sounded like a fight between two giant parrots, dropped in pitch.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("‘Two sets of vocal cords that operate simultaneously,” Axford explained, reducing the volume again. “It’s not so strange when you think about it. There were species of birds back home that sang this way. You can cram a lot of information into the combined sounds, using not just pitch and timbre but interference and counterpoint as well. I’m sure under other circumstances, it could be quite beautiful, but at this point, Charlie wasn’t trying to endear himself to me, I’m afraid. He wanted out. That much was obvious.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Did you communicate with it at all?” Hatzis asked. Her expression was one of cautious fascination as she watched the alien pounding on the walls of his cell, shrieking in harshly dissonant tones that echoed through "), _c('i', [_vm._v("Pearl")]), _vm._v(". She flinched every time its double voice reached a new peak of intensity.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford shook his head. “The language is simply too complicated,” he said with obvious disappointment. “Besides which, I didn’t get enough of it to make a detailed study. I’ve had a dozen of me working full time on it, but so far we haven’t had any breakthroughs.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander looked at Axford in mild surprise. He kept forgetting that there were hundreds of the man scattered across Vega, and yet most of the time he spoke as if there was only one of him. But then, as the original Hatzis had said, that was the problem with engrams: it didn’t matter that they were simulations run on software, they were all essentially locked to their original state and could not change. Even if there were a million Axfords, they would all still behave like the original. Deviation would simply not be tolerated.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("If only"), _c('i', [_vm._v(" his")]), _vm._v(" engram had been so robust, Alander thought. Just two out of all the systems they had surveyed wasn’t very good odds at finding someone else he could trust.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The symmetry of the alien continued to bother him. “Could it be an artificial body,” he suggested, “like ours?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Possibly,” Axford replied, nodding. “But then, I’d have to see an original before I could tell the difference.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And that’s where we come in?” Hatzis asked. “You want us to go looking for you? To find out where they come from, perhaps?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He shook his head again. “Frankly, where he comes from doesn’t particularly interest me,” he said. “It’s what he’s doing"), _c('i', [_vm._v(" now")]), _vm._v(" that matters.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A star map appeared, showing Vega and its near neighbors. Some were UNESSPRO targets—including Altair, Kruger 60, and Gamma Serpens—but there were others Alander wasn’t familiar with.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Your clone on Sothis,” Axford went on, “she said in her last broadcast that the Roaches had bothered a system not far from here.” The map moved to show Groombridge 1830.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Perendi,” said Hatzis, automatically naming the colony. She didn’t seem to take offense at her original being referred to as a clone.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Whatever. You also spotted a number of kills, through here.” Axford indicated an area between Vega Mid Groombridge 1830. “Now, there have been two unsuccessful Roach attacks in the last week, but the bait signals I picked up suggest they must have been successful elsewhere. And given that it’s all happening in roughly the same spot—cosmologically speaking, that is—I can’t help but wonder if they have a base somewhere nearby.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But we haven’t seen evidence of any alien installation around here,” said Hatzis.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Nor would you if you were looking in the wrong spot,” said Axford. “But maybe the aliens don’t like G- type stars. They could like M- or K- or F-types instead. For all we know, they might even go for brown dwarfs, drifting through interstellar space.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Surely they wouldn’t be able to support life?” said Hatzis.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“They can support life if their cores are still active,” offered Alander.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Maybe,” said Hatzis. “But they’d still be damn near impossible to find.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford shrugged. “I’m just thinking out loud here,” he said. “I’m not really suggesting we go on a Roach hunt just yet. I have another idea.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander had thought ahead. “61 Ursa Major,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Instead of looking annoyed that Alander had stolen his thunder, Axford seemed delighted. “I’m impressed, Doctor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Please don’t call me that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford frowned. “But that’s your title, isn’t it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Just Peter will be fine,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Both Hatzis and Axford stared at him for a moment, Hatzis with curiosity, Axford in puzzlement. The protest sounded childish and irrelevant even to his own ears, but each time he heard the title, he felt as if everything he had done to make his new self stable was being undone again. “Dr. Alander” had died on Earth in the Spike; he wasn’t entirely sure who"), _c('i', [_vm._v(" he")]), _vm._v(" was, yet, but it felt inappropriate to be addressed by someone else’s title. He didn’t think he had earned that right.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("If not for us, then for whom?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He had rarely thought of his last conversation with Lucia Benck since the destruction of the post-Spike civilization in Sol system. It didn’t have the same resonance as it used to, in the context of the new, hostile universe he’d been thrown into. What did it matter who you were, he thought, when you were only one of a bare handful of humans left anyway?")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford shrugged. “Okay,” he said. “If that’s what makes you happy, then Peter it is.” He turned to Hatzis. “And what about you, Caryl? Anything in particular you like to be addressed as? Madam President, perhaps? Or maybe I should be swearing allegiance to your Congress of Orphans?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“How did you—?” Hatzis stopped with a furious flush on her face.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford’s laugh echoed through"), _c('i', [_vm._v(" Pearl.")]), _vm._v(" “You really should tell your mother superior to find a better way of broadcasting her secrets,” he said. “I’m sure she doesn’t want just anyone listening in, does she?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis’s gazed flicked to Alander, then back. “I’ve no idea what you’re talking about,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander observed the exchange with fascination. What had Axford caught Hatzis doing? And not just this Hatzis, but"), _c('i', [_vm._v(" all")]), _vm._v(" of them. Whatever the Congress of Orphans was, and however the information was being disseminated, he obviously wasn’t supposed to know about it. He would have to take a closer look at the broadcasts from Sothis in the future.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“When you two have finished,” Alander said, deliberately playing down the matter, “do you think we could get back to the business of 61 Ursa Major?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Right.” Hatzis was obviously relieved that he was changing the subject.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“If the Spinners are progressing the way we think they are,” Alander went on, “then they’ll be arriving there any time—with the Roaches not far behind them. So, my guess, General, is that you want to set an ambush, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Of sorts.” Axford brought the image of the alien back into the foreground. “We have here an important piece of intelligence, but he’s no use unless we can figure out how to talk to him. The Gifts have no record of this species and therefore no record of their language, oral or written. We could try digging magnetic electrodes into its brain—the regions that were most active when it was shouting before might tell us"), _c('i', [_vm._v(" something")]), _vm._v("—but that’s a desperate measure, and a short-term one at best. If Charlie dies, for whatever reason, then we’re right back where we started.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Then what"), _c('i', [_vm._v(" are")]), _vm._v(" you proposing?” asked Hatzis.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, I’m presuming that their hole ships speak to them in their own language and know something about their physical needs,” said Axford. “If we can get close enough to one, I can merge the nodes of the AIs and get my hands on that information. Once we’ve got"), _c('i', [_vm._v(" that,")]), _vm._v(" I can use it on Charlie here to make him useful.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You mean torture him?” she asked with distaste.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“If reviving him, feeding him, and asking him a few questions about where he comes from counts as torture, then, yes, I guess we’ll be torturing him.” Axford’s eyes flashed dangerously. “What do you take me for? I’m not in the CIA anymore, you know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yet you deliberately wiped out your crewmates and—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Okay, okay,” Alander cut in. “Once we talk to it, what then?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Then we see what it has to say, I guess.” Axford leaned back into his chair with a sigh. “Who knows who these people are? Or what they want?"), _c('i', [_vm._v(" That")]), _vm._v(" information is our priority, not what we do with it once we’ve got it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But they haven’t tried to communicate with us before now,” said Hatzis. “Who’s to say they’ll want to communicate with us at all?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m aware of that,” he said. “But I don’t see that we have much choice right now.” His gaze studied both of them in turn. “So what do you say? Are you in, or not?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What exactly is it you want us to do?” Hatzis asked after a moment’s consideration.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, for a start, surveillance will be a whole lot easier with two hole ships rather than one,” he said. “We’ll need to keep a low profile, otherwise they’ll think the gifts have already been opened and move on. Once they"), _c('i', [_vm._v(" are ")]), _vm._v("there, then you can distract them while I move in. I don’t know how long it’ll take, so I don’t know how long we have to pin them down for—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Do you even know whether it’s going to work?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Of course not,” he said. “But I figure it’s worth a try. I didn’t know I could merge the AI lobes, either, until I tried it with you. It was just an idea I picked up from something in the library. It paid off, and this might, too. If it doesn’t work, then what’s the worst that can happen?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis stared balefully at him. “They’ll know how to modify their hole ships, too,” she said. “They might also have weapons.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“They do, but they’re not invincible.” Axford indicated the alien with a smirk. “Charlie is proof of that,” he said. “And anyway, they’ve shown a marked tendency to run when confronted. Unless we force them into a corner, as I did here, then I doubt they’ll even want to fight. Like I said, they’re nothing but scavengers.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford glanced significantly at Alander, and Alander wondered what he was trying to tell him. There was a whole other level to the conversation, all of a sudden.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Excuse me,” he said. “I need a break. The disorientation...”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford nodded. “Come back when you’re ready. Caryl and I will work out the finer points together.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hatzis looked annoyed but didn’t say anything. “What steps do you plan to take to guarantee the safety of the colony?” she asked Axford as Alander disconnected his presence from the virtual conference. There followed a small jolt of dislocation, then he was back in the smooth emptiness of"), _c('i', [_vm._v(" Pearl’s")]), _vm._v(" cockpit, alone apart from Thor’s inert body.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“She’s a slippery character,” said a voice from behind him, startling him. “You’ll have to keep an eye on her. Or, I should say,"), _c('i', [_vm._v(" them")]), _vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander turned on the couch to see Frank the Ax near to the exit, leaning against the wall of the cockpit.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Tell you the truth,” Alander said, standing, “I’m more concerned about you right now than I am about Caryl.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford’s brow creased. “What do you mean?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I think you have your own long-term objectives,” said Alander. “Objectives that might not match ours.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And just what"), _c('i', [_vm._v(" are")]), _vm._v(" your long-term objectives, Peter?” Axford straightened and took two steps toward him. ‘‘Where do"), _c('i', [_vm._v(" you")]), _vm._v(" see yourself in a year from now? Or a decade, even? A"), _c('i', [_vm._v(" century")]), _vm._v("?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander laughed dryly. “I have trouble seeing ahead a month.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s not true,” Axford replied curtly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Maybe not,” said Alander, “but it feels like it, sometimes.” He glanced at the android of Caryl Hatzis, sitting motionless on the couch. “Are you sure she’s not listening to us?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He nodded. “Four-oh-six is keeping her occupied.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I thought his number was ten-twenty-two?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It was originally,” he said. “Then eight-ninety-two took over negotiations when you arrived in Hermes. Perfectly seamless. I’m three-fifty-eight,” he said. “The numbers are chronological, so I’m one of the older iterations. I can feel my algorithms getting a little creaky. When I start making mistakes, they’ll be replaced.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You mean"), _c('i', [_vm._v(" you’ll")]), _vm._v(" be replaced, don’t you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Not at all,” said Axford. “I am nothing but the sum of my memories and my personality. The personality is identical in its primary form, and the memories can be copied perfectly from engram to engram. There will be no loss of identity.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But it won’t be"), _c('i', [_vm._v(" you,")]), _vm._v(" will it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford laughed at his confusion. “You’re grappling with philosophical questions that were of no concern to the original Francis T. Axford. Therefore, as you are well aware, they’re of no concern to me. I’m the ideal person to found a society like this, you know, because at no point am I bothered by such meaningless concepts as the soul. I am a product of what I do and what I remember. There is nothing else.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander put aside the problem for a moment; perhaps, as Axford suggested, the distinction of who was who—")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("If not us..")]), _vm._v("."), _c('i', [_vm._v(" ?")]), _vm._v("—was irrelevant.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Anyway,” said Alander, “I’m more interested in what it is you’re doing rather than who exactly it is doing it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And so you should be.” Axford’s expression sobered as he came around the cockpit to face Alander.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford was a product of conSense, but he seemed perfectly real. And surprisingly short in person, Alander thought.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What exactly is it that concerns you, Peter? You should tell me now, before we agree to work together, because I don’t want an ally turning on me in the middle of a tricky maneuver.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Ally")]), _vm._v(", Alander noted. "), _c('i', [_vm._v("There’s that word again.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You said these Roaches are reluctant to fight unless cornered,” he said. “I’m assuming you must have trapped them in here when they came to steal the gifts.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s right,” Axford replied. “There are ways to impede a hole ship’s ability to relocate, you see. The exterior of this habitat bubble has been treated to prevent anyone escaping—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("Anyone?")]), _vm._v("” Alander cut in quickly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford smiled casually. “I haven’t said that you’re prisoners, have I?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander held his gaze steadily. “So"), _c('i', [_vm._v(" are")]), _vm._v(" we?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, let’s see what happens when you try to leave,” said Axford, his smile widening. He was enjoying the game, splitting hairs with the precision of atomic force microscopy. “We have a very democratic process, here,” he continued. “We all come to the same decision because we’re all the same person; the votes are invariably unanimous. Could you say the same about your own ragtag collective?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("‘There’s strength in diversity,” Alander defended.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I know,” said Axford. “Which is why I want your cooperation.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And if we don’t want yours?” asked Alander.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford smiled faintly. “Unless you seriously disagree with me on matters of policy and the implementation of the same, then you’ll leave here unimpeded.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander snorted a derisive laugh. “Is that a threat? Agree or be incarcerated?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Not at all. I would never waste resources keeping you prisoner for long. It’d be much more sensible to kill you and use your hole ship myself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander could see that Axford wasn’t joking. There was no trace of humor in the man’s gray eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But I’m not intending to threaten you, Peter. I’m simply stating a strategic reality: if we can’t agree on the basic terms, then it simply wouldn’t be safe for me to let you leave. You know things about this establishment that I can’t afford to have disseminated—that it exists at all, for a start. If the Roaches or the Starfish ever learned what I have here—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“They won’t even"), _c('i', [_vm._v(" talk")]), _vm._v(" to us,” interrupted Alander. “How the hell are we supposed to pass on vital information about your base here?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You actually have to ask that?” He shook his head as if disappointed. “The way you people spray information around, I’d say being paranoid about it would be the most prudent response. Listen, Peter, you people give away tactical information on the location of your bases, your core population, your resources—everything! All you need is for someone with a communicator to crack your encryption, and you’re in deep shit, my friend. I have no intentions of being dragged down with you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As much as he didn’t want to admit it, Alander knew Axford had a point. He had once been a staunch supporter of daily broadcasts designed to alert new colonies to the dangers of using the Spinner communicators. But they had changed in content to become something completely different from what he’d originally envisaged. They were becoming bloated tracts of policy and—as Axford had rightly pointed out—tactical information. And if his earlier comments about the Congress of Orphans weren’t simply a cheap destabilizing tactic, then maybe there was something else in them, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Why would you bring us here at all, then,” said Alander, “if you felt it could be such a risk? In fact, why are you even talking to me"), _c('i', [_vm._v(" now")]), _vm._v("?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford smiled. “Your friend here...” He nodded to Hatzis on the couch. “She thinks I want to take over the galaxy—spread through it like a plague or something. And maybe she’s right: maybe one day I"), _c('i', [_vm._v(" would")]), _vm._v(" like to do just that. But I know that strength of numbers isn’t everything. There could be a billion of me, swarming over your colonies, and all you’d have to do was devise a virus that targets a chink in my personality—and"), _c('i', [_vm._v(" bam,")]), _vm._v(" you’ve taken me out overnight. So when you say there is strength in diversity, you’re absolutely right. There’s a balance, somewhere, where there’s more than enough of"), _c('i', [_vm._v(" me")]), _vm._v(" and just the right amount of everyone else to make us all strong. At the moment, I’m simply trying to find the balance.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And who, exactly,” Alander asked, “is ‘everyone else’?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s the billion-dollar question, isn’t it?” said Axford, although he didn’t offer to elaborate.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander stared at him, furiously trying to work out what Frank the Ax could possibly want that he didn’t already have. It wouldn’t be something as general as safety or security, because Axford thought in terms of specifics. He must have some specific goal in mind, or else taking such risks as inviting Hatzis and Alander to his main base—regardless of what he said about them being unable to escape—made no sense. He needed them to help him do something. And if he was making Alander work out what it was on his own, and without Hatzis present, then the chances were it was something—")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The truth hit him midthought and, when it came, he didn’t know whether to admire the man’s audacity or fear what he could bring down upon them all.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“When you talk about"), _c('i', [_vm._v(" allies")]), _vm._v(",” Alander said slowly, “you’re not just talking about us, are you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford smiled, clearly pleased Alander had worked it out.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You’re talking about the Roaches,” Alander went on.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You want them to help you do what you can’t do on your own.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Alander hesitated on the brink, thinking:"), _c('i', [_vm._v(" Ultimately it ")]), _vm._v("is"), _c('i', [_vm._v(" about security, and there’s really only one way to be totally secure")]), _vm._v(". But it could also be about revenge. “You want them to help you attack the Starfish.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Axford’s expression became serious as he nodded and said, “Yes, I do. And if I get it right, it won’t be suicide.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e6b3470","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section8.vue
// module id = 87
// module chunks = 0